const routeOptions = {
  "nuts-fruits-party-packs": [
    {
      type: "checkbox",
      variantIds: [31230154276934, 48635808591, 29554381815878, 42224494739526],
      maxChecked: 4,
      qty: 1,
      name: "Flavours",
      label: "Flavours (Up to 4)",
      tooltip: "We will apportion your selected flavours equally",
      snacks: popularSnackOptionsParty,
    },
    {
      type: "checkbox",
      variantIds: [40682908549190, 40682908581958, 40682908614726],
      maxChecked: 4,
      qty: 1,
      name: "Flavours",
      label: "Flavours (Up to 4)",
      tooltip: "We will apportion your selected flavours equally",
      snacks: popularSnackOptionsGift,
    },
    {
      type: "imageSelect",
      variantIds: [31230154276934, 40682908549190, 42224494739526],
      qty: 1,
      name: "Label",
      label: "Choose your label",
      tooltip: "Size (LxH): 5.5cm x 4.5cm",
      images: imageOptions,
    },
    {
      type: "imageSelect",
      variantIds: [48635808591, 29554381815878, 40682908581958, 40682908614726],
      qty: 1,
      name: "Label",
      label: "Choose your label",
      tooltip: "Size (LxH): 5.5cm x 4.5cm",
      images: imageOptions.concat([
        {
          name: "Custom",
          url: "https://cdn.shopify.com/s/files/1/1717/9065/files/Custom_label.jpg?v=1692952705",
        },
      ]),
    },
    {
      type: "imageSelect",
      variantIds: [41239587848262],
      qty: 1,
      name: "Label",
      label: "Upload your label",
      tooltip: "Size (LxH): 5.5cm x 4.5cm",
      images: [
        {
          name: "Custom",
          url: "https://cdn.shopify.com/s/files/1/1717/9065/files/Custom_label.jpg?v=1692952705",
        },
      ],
    },
    {
      type: "display",
      variantIds: [32262394183750],
      html: `<p>Box only excludes snacks</p>`,
    },
    {
      type: "checkbox",
      variantIds: [44108148244550],
      maxChecked: 4,
      qty: 1,
      name: "Flavours",
      label: "Flavours (Up to 4)",
      tooltip: "We will apportion your selected flavours equally",
      snacks: popularSnackOptionsGift,
    },
  ],
  "biscuits-party-packs": [
    {
      type: "checkbox",
      variantIds: [31230183702598, 48635542479, 40279310139462, 42948443144262],
      maxChecked: 4,
      qty: 1,
      name: "Flavours",
      label: "Choose up to 4 flavours",
      tooltip: "We will apportion your selected flavours equally",
      snacks: biscuitOptionsParty,
    },
    {
      type: "checkbox",
      variantIds: [40682902421574, 40682902454342, 40682902487110],
      maxChecked: 4,
      qty: 1,
      name: "Flavours",
      label: "Choose up to 4 flavours",
      tooltip: "We will apportion your selected flavours equally",
      snacks: biscuitOptionsGift,
    },
    {
      type: "imageSelect",
      variantIds: [31230183702598, 40682902421574, 42948443144262],
      qty: 1,
      name: "Label",
      label: "Choose your label",
      tooltip: "Size (LxH): 5.5cm x 4.5cm",
      images: imageOptions,
    },
    {
      type: "imageSelect",
      variantIds: [48635542479, 40279310139462, 40682902454342, 40682902487110],
      qty: 1,
      name: "Label",
      label: "Choose your label",
      tooltip: "Size (LxH): 5.5cm x 4.5cm",
      images: imageOptions.concat([
        {
          name: "Custom",
          url: "https://cdn.shopify.com/s/files/1/1717/9065/files/Custom_label.jpg?v=1692952705",
        },
      ]),
    },
    {
      type: "imageSelect",
      variantIds: [42948443111494],
      qty: 1,
      name: "Label",
      label: "Upload your label",
      tooltip: "Size (LxH): 5.5cm x 4.5cm",
      images: [
        {
          name: "Custom",
          url: "https://cdn.shopify.com/s/files/1/1717/9065/files/Custom_label.jpg?v=1692952705",
        },
      ],
    },
    {
      type: "checkbox",
      variantIds: [44108115640390],
      maxChecked: 4,
      qty: 1,
      name: "Flavours",
      label: "Flavours (Up to 4)",
      tooltip: "We will apportion your selected flavours equally",
      snacks: biscuitOptionsGift,
    },
  ],
  "cookies-party-packs-gift-packs": [
    {
      type: "checkbox",
      variantIds: [40636064858182, 40636064890950, 40636064923718, 40694286155846, 43851517984838],
      maxChecked: 4,
      qty: 1,
      name: "Flavours",
      label: "Flavours (Up to 4)",
      tooltip: "We will apportion your selected flavours equally",
      snacks: cookieOptionsParty,
    },
    {
      type: "checkbox",
      variantIds: [40694208364614, 40694208397382, 40694208430150, 40694286188614],
      maxChecked: 4,
      qty: 1,
      name: "Flavours",
      label: "Flavours (Up to 4)",
      tooltip: "We will apportion your selected flavours equally",
      snacks: cookieOptionsGift,
    },
    {
      type: "imageSelect",
      variantIds: [40636064858182, 40694208364614, 40694286155846, 40694286188614, 43851517984838],
      qty: 1,
      name: "Label",
      label: "Choose your label",
      tooltip: "Size (LxH): 5.5cm x 4.5cm",
      images: imageOptions,
    },
    {
      type: "imageSelect",
      variantIds: [40636064890950, 40636064923718, 40694208397382, 40694208430150],
      qty: 1,
      name: "Label",
      label: "Choose your label",
      tooltip: "Size (LxH): 5.5cm x 4.5cm",
      images: imageOptions.concat([
        {
          name: "Custom",
          url: "https://cdn.shopify.com/s/files/1/1717/9065/files/Custom_label.jpg?v=1692952705",
        },
      ]),
    },
    {
      type: "checkbox",
      variantIds: [44108431196230],
      maxChecked: 4,
      qty: 1,
      name: "Flavours",
      label: "Flavours (Up to 4)",
      tooltip: "We will apportion your selected flavours equally",
      snacks: cookieOptionsGift,
    },
  ],
  "honey-tea-sachets-party-packs": [
    {
      type: "checkbox",
      variantIds: [44514305441862],
      maxChecked: 1,
      qty: 1,
      name: "Flavours",
      label: "Flavour",
      snacks: teaPartyPackOptions.concat(honeyPartyPackOptions),
    },
    {
      type: "checkbox",
      variantIds: [44514338078790, 44514338111558, 44514338242630],
      maxChecked: 4,
      qty: 1,
      name: "Flavours",
      label: "Choose up to 4 flavours",
      tooltip: "We will apportion your selected flavours equally",
      snacks: teaPartyPackOptions.concat(honeyPartyPackOptions),
    },
    {
      type: "checkbox",
      variantIds: [44666656325702],
      maxChecked: 1,
      qty: 1,
      name: "Snack",
      label: "Choose 1 snack",
      snacks: popularSnackOptionsParty.concat(biscuitOptionsParty),
    },
    {
      type: "checkbox",
      variantIds: [44666656325702],
      maxChecked: 1,
      qty: 1,
      name: "Tea",
      label: "Choose 1 tea",
      snacks: teaPartyPackOptions,
    },
    {
      type: "checkbox",
      variantIds: [44666656325702],
      maxChecked: 1,
      qty: 1,
      name: "Honey",
      label: "Choose 1 honey",
      snacks: honeyPartyPackOptions,
    },
    {
      type: "checkbox",
      variantIds: [44514338275398],
      maxChecked: 2,
      qty: 1,
      name: "Snacks",
      label: "Choose 2 snacks",
      snacks: popularSnackOptionsParty.concat(biscuitOptionsParty),
    },
    {
      type: "checkbox",
      variantIds: [44514338275398],
      maxChecked: 2,
      qty: 1,
      name: "Teas",
      label: "Choose 2 teas",
      snacks: teaPartyPackOptions,
    },
    {
      type: "checkbox",
      variantIds: [44514338308166],
      maxChecked: 2,
      qty: 1,
      name: "Snacks",
      label: "Choose 2 snacks",
      snacks: popularSnackOptionsParty.concat(biscuitOptionsParty),
    },
    {
      type: "checkbox",
      variantIds: [44514338308166],
      maxChecked: 2,
      qty: 1,
      name: "Teas",
      label: "Choose 2 teas",
      snacks: teaPartyPackOptions,
    },
    {
      type: "checkbox",
      variantIds: [44514338308166],
      maxChecked: 2,
      qty: 1,
      name: "Honeys",
      label: "Choose 2 honeys",
      snacks: honeyPartyPackOptions,
    },
  ],
  "snacks-with-tea-and-honey-divine-glow-gift-sets" : [
    // Golden harmony
    {
      type: "checkbox",
      variantIds: [44794555596870],
      maxChecked: 2,
      qty: 1,
      name: "Honey",
      label: "Choose Honey Flavours",
      tooltip: "We will apportion your selected flavours equally.",
      snacks: honeyPartyPackOptions,
    },
    {
      type: "checkbox",
      variantIds: [44794555596870],
      maxChecked: 2,
      qty: 1,
      name: "Tea",
      label: "Choose Tea Flavours",
      tooltip: "We will apportion your selected flavours equally.",
      snacks: teaPartyPackOptions,
    },
    // Golden wellness
    {
      type: "checkbox",
      variantIds: [44794555990086],
      maxChecked: 4,
      qty: 1,
      name: "Honey",
      label: "Choose Honey Flavours",
      tooltip: "We will apportion your selected flavours equally.",
      snacks: honeyPartyPackOptions,
    },
    {
      type: "checkbox",
      variantIds: [44794555990086],
      maxChecked: 4,
      qty: 1,
      name: "Tea",
      label: "Choose Tea Flavours",
      tooltip: "We will apportion your selected flavours equally.",
      snacks: teaPartyPackOptions,
    },
    // Golden clarity
    {
      type: "checkbox",
      variantIds: [44794556022854],
      maxChecked: 6,
      qty: 1,
      name: "Honey",
      label: "Choose Honey Flavours",
      tooltip: "We will apportion your selected flavours equally.",
      snacks: honeyPartyPackOptions,
    },
    {
      type: "checkbox",
      variantIds: [44794556022854],
      maxChecked: 6,
      qty: 1,
      name: "Tea",
      label: "Choose Tea Flavours",
      tooltip: "We will apportion your selected flavours equally.",
      snacks: teaPartyPackOptions,
    },
    // Golden tranquility
    {
      type: "checkbox",
      variantIds: [44794556055622],
      maxChecked: 8,
      qty: 1,
      name: "Honey",
      label: "Choose Honey Flavours",
      tooltip: "We will apportion your selected flavours equally.",
      snacks: honeyPartyPackOptions,
    },
    {
      type: "checkbox",
      variantIds: [44794556055622],
      maxChecked: 8,
      qty: 1,
      name: "Tea",
      label: "Choose Tea Flavours",
      tooltip: "We will apportion your selected flavours equally.",
      snacks: teaPartyPackOptions,
    },
    // Glow relax
    {
      type: "checkbox",
      variantIds: [44794555629638],
      maxChecked: 2,
      qty: 1,
      name: "Snacks",
      label: "Choose Nuts and Snacks Flavours",
      tooltip: "We will apportion your selected flavours equally.",
      snacks: popularSnackOptionsParty,
    },
    {
      type: "checkbox",
      variantIds: [44794555629638],
      maxChecked: 2,
      qty: 1,
      name: "Tea",
      label: "Choose Tea Flavours",
      tooltip: "We will apportion your selected flavours equally.",
      snacks: teaPartyPackOptions,
    },
    {
      type: "checkbox",
      variantIds: [44794555629638],
      maxChecked: 2,
      qty: 1,
      name: "Honey",
      label: "Choose Honey Flavours",
      tooltip: "We will apportion your selected flavours equally.",
      snacks: honeyPartyPackOptions,
    },
    // Glow recharge
    {
      type: "checkbox",
      variantIds: [44794556088390],
      maxChecked: 3,
      qty: 1,
      name: "Snacks",
      label: "Choose Nuts and Snacks Flavours",
      tooltip: "We will apportion your selected flavours equally.",
      snacks: popularSnackOptionsParty,
    },
    {
      type: "checkbox",
      variantIds: [44794556088390],
      maxChecked: 3,
      qty: 1,
      name: "Tea",
      label: "Choose Tea Flavours",
      tooltip: "We will apportion your selected flavours equally.",
      snacks: teaPartyPackOptions,
    },
    {
      type: "checkbox",
      variantIds: [44794556088390],
      maxChecked: 3,
      qty: 1,
      name: "Honey",
      label: "Choose Honey Flavours",
      tooltip: "We will apportion your selected flavours equally.",
      snacks: honeyPartyPackOptions,
    },
    // Glow refresh
    {
      type: "checkbox",
      variantIds: [44794556121158],
      maxChecked: 4,
      qty: 1,
      name: "Snacks",
      label: "Choose Nuts and Snacks Flavours",
      tooltip: "We will apportion your selected flavours equally.",
      snacks: popularSnackOptionsParty,
    },
    {
      type: "checkbox",
      variantIds: [44794556121158],
      maxChecked: 4,
      qty: 1,
      name: "Tea",
      label: "Choose Tea Flavours",
      tooltip: "We will apportion your selected flavours equally.",
      snacks: teaPartyPackOptions,
    },
    {
      type: "checkbox",
      variantIds: [44794556121158],
      maxChecked: 4,
      qty: 1,
      name: "Honey",
      label: "Choose Honey Flavours",
      tooltip: "We will apportion your selected flavours equally.",
      snacks: honeyPartyPackOptions,
    },
    // Glow revive
    {
      type: "checkbox",
      variantIds: [44794556153926],
      maxChecked: 6,
      qty: 1,
      name: "Snacks",
      label: "Choose Nuts and Snacks Flavours",
      tooltip: "We will apportion your selected flavours equally.",
      snacks: popularSnackOptionsParty,
    },
    {
      type: "checkbox",
      variantIds: [44794556153926],
      maxChecked: 6,
      qty: 1,
      name: "Tea",
      label: "Choose Tea Flavours",
      tooltip: "We will apportion your selected flavours equally.",
      snacks: teaPartyPackOptions,
    },
    {
      type: "checkbox",
      variantIds: [44794556153926],
      maxChecked: 6,
      qty: 1,
      name: "Honey",
      label: "Choose Honey Flavours",
      tooltip: "We will apportion your selected flavours equally.",
      snacks: honeyPartyPackOptions,
    },
    // individuals
    {
      type: "checkbox",
      variantIds: [44794555662406],
      maxChecked: 1,
      qty: 1,
      name: "Tea",
      label: "Choose Tea Flavour",
      snacks: teaPartyPackOptions,
    },
    {
      type: "checkbox",
      variantIds: [44794556186694],
      maxChecked: 1,
      qty: 1,
      name: "Honey",
      label: "Choose Honey Flavour",
      snacks: honeyPartyPackOptions,
    },
    // nutrition
    {
      type: "checkbox",
      variantIds: [44794556219462],
      maxChecked: 1,
      qty: 1,
      name: "Snacks",
      label: "Choose Nuts and Snacks Flavour",
      snacks: popularSnackOptionsParty,
    },
    {
      type: "checkbox",
      variantIds: [44794556219462],
      maxChecked: 1,
      qty: 1,
      name: "Honey",
      label: "Choose Honey Flavour",
      snacks: honeyPartyPackOptions,
    },
    // vitality
    {
      type: "checkbox",
      variantIds: [44794556252230],
      maxChecked: 1,
      qty: 1,
      name: "Snacks",
      label: "Choose Nuts and Snacks Flavour",
      snacks: popularSnackOptionsParty,
    },
    {
      type: "checkbox",
      variantIds: [44794556252230],
      maxChecked: 1,
      qty: 1,
      name: "Tea",
      label: "Choose Tea Flavour",
      snacks: teaPartyPackOptions,
    },
    {
      type: "checkbox",
      variantIds: [44794556252230],
      maxChecked: 1,
      qty: 1,
      name: "Honey",
      label: "Choose Honey Flavour",
      snacks: honeyPartyPackOptions,
    },
  ],
  "snacks-goodie-box": [
    {
      type: "checkbox",
      variantIds: [43711299551302, 43711299584070, 43711299616838],
      maxChecked: 4,
      qty: 1,
      name: "Flavours",
      label: "Choose up to 4 flavours",
      tooltip: "We will apportion your selected flavours equally",
      snacks: goodieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [43711299878982],
      maxChecked: 3,
      qty: 1,
      name: "Flavours",
      label: "Choose up to 3 flavours",
      tooltip: "We will apportion your selected flavours equally",
      snacks: goodieBoxOptions,
    },
  ],
  "snacks-snackie-box": [
    {
      type: "checkbox",
      variantIds: [42041830703174, 42041830768710, 42041830834246],
      maxChecked: 4,
      qty: 1,
      name: "Flavours",
      label: "Choose up to 4 flavours",
      tooltip: "We will apportion your selected flavours equally",
      snacks: snackieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [43703800889414],
      maxChecked: 6,
      qty: 1,
      name: "Flavours",
      label: "Choose 6 flavours",
      tooltip: "We will apportion your selected flavours equally if necessary",
      snacks: snackieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [42088692383814],
      maxChecked: 1,
      qty: 1,
      name: "Goodie Case",
      label: "Choose 1 Goodie Case",
      snacks: goodieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [42088692383814],
      maxChecked: 1,
      qty: 1,
      name: "Snackie Case",
      label: "Choose 1 Snackie Case",
      snacks: snackieBoxOptions,
    },
    {
      type: "textField",
      variantIds: [42088692383814, 43703800889414],
      name: "Message",
      label: "Your message on card",
    },
  ],
  "snacks-in-cutie-box": [
    {
      type: "checkbox",
      variantIds: [42948940628038, 42948940660806, 42948940693574],
      maxChecked: 4,
      qty: 1,
      name: "Flavours",
      label: "Choose up to 4 flavours",
      tooltip: "We will apportion your selected snacks equally",
      snacks: cutieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [43142772916294],
      maxChecked: 4,
      qty: 1,
      name: "Cutie Boxes",
      label: "Choose up to 4 Cutie Boxes",
      tooltip: "We will apportion your selected snacks equally",
      snacks: cutieBoxOptions,
    },
  ],
  "custom-snacks-display-box": [
    {
      type: "checkbox",
      variantIds: [40308392493126, 40686879932486],
      maxChecked: 4,
      qty: 1,
      name: "Flavours",
      label: "Choose up to 4 flavours",
      tooltip: "We will apportion your selected flavours equally",
      snacks: popularSnackOptionsParty,
    },
    {
      type: "imageSelect",
      variantIds: [40308392493126, 40686879932486],
      qty: 1,
      name: "Label",
      label: "Choose your label",
      tooltip: "Size (LxH): 5.5cm x 4.5cm",
      images: imageOptions,
    },
  ],
  "retail-packs": [
    {
      type: "checkbox",
      variantIds: [40731447853126, 40275672334406, 40706726068294],
      maxChecked: 4,
      qty: 1,
      name: "Flavours",
      label: "Flavours (Up to 4)",
      tooltip: "We will apportion your selected flavours equally",
      snacks: popularSnackOptionsRetail,
    },
  ],
  "custom-snack-box": [
    {
      type: "checkbox",
      variantIds: [42438179848262],
      maxChecked: 3,
      qty: 1,
      name: "Retail Pack",
      label: "Choose up to 3 retail packs",
      snacks: biscuitOptionsRetail,
    },
    {
      type: "checkbox",
      variantIds: [31598564769862],
      maxChecked: 3,
      qty: 1,
      name: "Retail Pack",
      label: "Choose up to 3 retail packs",
      snacks: popularSnackOptionsRetail,
    },
    {
      type: "checkbox",
      variantIds: [41076791476294],
      qty: 1,
      maxChecked: 2,
      name: "Retail pack",
      label: "Choose up to 2 retail packs",
      tooltip: "We will apportion your selected flavours equally",
      snacks: popularSnackOptionsRetail,
    },
    {
      type: "checkbox",
      variantIds: [41076791476294],
      qty: 1,
      maxChecked: 2,
      name: "Snackie Case",
      label: "Choose up to 2 Snackie Cases",
      tooltip: "We will apportion your selected flavours equally",
      snacks: snackieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [41085747429446],
      qty: 1,
      maxChecked: 1,
      name: "Retail pack",
      label: "Choose 1 retail pack",
      snacks: popularSnackOptionsRetail,
    },
    {
      type: "checkbox",
      variantIds: [41085747429446],
      qty: 1,
      maxChecked: 2,
      name: "Snackie Case",
      label: "Choose up to 2 Snackie Cases",
      tooltip: "We will apportion your selected flavours equally",
      snacks: snackieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [41085747429446],
      qty: 1,
      maxChecked: 2,
      name: "Goodie Case",
      label: "Choose up to 2 Goodie Cases",
      tooltip: "We will apportion your selected flavours equally",
      snacks: goodieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [42088932245574],
      qty: 1,
      maxChecked: 6,
      name: "Snackie Case",
      label: "Choose up to 6 Snackie Cases",
      tooltip: "We will apportion your selected flavours equally",
      snacks: snackieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [42107179073606],
      qty: 1,
      maxChecked: 4,
      name: "Party packs",
      label: "Choose up to 4 flavours",
      tooltip: "We will apportion your selected flavours equally",
      snacks: popularSnackOptionsParty,
    },
    {
      type: "checkbox",
      variantIds: [42107179106374],
      qty: 1,
      maxChecked: 4,
      name: "Party packs",
      label: "Choose up to 4 flavours",
      tooltip: "We will apportion your selected flavours equally",
      snacks: popularSnackOptionsParty,
    },
    {
      type: "checkbox",
      variantIds: [42107179106374],
      qty: 1,
      maxChecked: 1,
      name: "Snackie Case",
      label: "Choose 1 Snackie Case",
      snacks: snackieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [42107179139142],
      qty: 1,
      maxChecked: 1,
      name: "Snackie Case",
      label: "Choose 1 Snackie Case",
      snacks: snackieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [42107179139142],
      qty: 1,
      maxChecked: 1,
      name: "Goodie Case",
      label: "Choose 1 Goodie Case",
      snacks: goodieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [42135604363334],
      qty: 1,
      maxChecked: 3,
      name: "Goodie Case",
      label: "Choose up to 3 Goodie Cases",
      snacks: goodieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [42107179204678],
      qty: 1,
      maxChecked: 3,
      name: "Gift Packs",
      label: "Choose up to 3 Gift Packs",
      snacks: popularSnackOptionsGift,
    },
    {
      type: "checkbox",
      variantIds: [42107179237446],
      qty: 1,
      maxChecked: 4,
      name: "Gift Packs",
      label: "Choose up to 4 Gift Packs",
      snacks: popularSnackOptionsGift,
    },
    {
      type: "checkbox",
      variantIds: [42107179270214],
      qty: 1,
      maxChecked: 6,
      name: "Gift Packs",
      label: "Choose up to 6 Gift Packs",
      tooltip: "We will apportion your selected flavours equally",
      snacks: popularSnackOptionsGift,
    },
    // Delight set
    {
      type: "checkbox",
      variantIds: [43839709839430],
      qty: 1,
      maxChecked: 3,
      name: "Biscuit Gift Packs",
      label: "Choose up to 3 Biscuit Gift Packs",
      tooltip: "We will apportion your selected flavours equally if needed",
      snacks: biscuitOptionsGift,
    },
    {
      type: "checkbox",
      variantIds: [42946765717574],
      qty: 1,
      maxChecked: 3,
      name: "Gift Packs",
      label: "Choose up to 3 Nuts and Fruits Gift Packs",
      tooltip: "We will apportion your selected flavours equally",
      snacks: popularSnackOptionsGift,
    },
    {
      type: "checkbox",
      variantIds: [42946766405702],
      qty: 1,
      maxChecked: 1,
      name: "Gift Packs",
      label: "Choose 1 Gift Pack",
      snacks: popularSnackOptionsGift,
    },
    {
      type: "checkbox",
      variantIds: [42946766405702],
      qty: 1,
      maxChecked: 2,
      name: "Cutie Boxes",
      label: "Choose up to 2 Cutie Boxes",
      tooltip: "We will apportion your selected flavours equally",
      snacks: cutieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [42946766635078],
      qty: 1,
      maxChecked: 2,
      name: "Gift Packs",
      label: "Choose up to 2 Gift Packs",
      tooltip: "We will apportion your selected flavours equally",
      snacks: popularSnackOptionsGift,
    },
    {
      type: "checkbox",
      variantIds: [42946766635078],
      qty: 1,
      maxChecked: 2,
      name: "Cutie Boxes",
      label: "Choose up to 2 Cutie Boxes",
      tooltip: "We will apportion your selected flavours equally",
      snacks: cutieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [42946767126598],
      qty: 1,
      maxChecked: 4,
      name: "Cutie Boxes",
      label: "Choose up to 4 Cutie Boxes",
      tooltip: "We will apportion your selected flavours equally",
      snacks: cutieBoxOptions,
    },
    // Glitter - 8 gift packs
    {
      type: "checkbox",
      variantIds: [43711594332230],
      qty: 1,
      maxChecked: 8,
      name: "Gift Packs",
      label: "Choose up to 8 flavours",
      tooltip: "We will apportion your selected flavours equally",
      snacks: popularSnackOptionsGift,
    },
    // Glitter - 12 gift packs
    {
      type: "checkbox",
      variantIds: [43711594364998],
      qty: 1,
      maxChecked: 12,
      name: "Gift Packs",
      label: "Choose up to 12 flavours",
      tooltip: "We will apportion your selected flavours equally",
      snacks: popularSnackOptionsGift,
    },
    // Bloom Box - Blessed
    {
      type: "checkbox",
      variantIds: [44081027973190],
      qty: 1,
      maxChecked: 2,
      name: "Retail pack",
      label: "Choose up to 2 retail packs",
      tooltip: "We will apportion your selected flavours equally",
      snacks: popularSnackOptionsRetail,
    },
    // Bloom Box - Blissful
    {
      type: "checkbox",
      variantIds: [44081028005958],
      qty: 1,
      maxChecked: 1,
      name: "Retail pack",
      label: "Choose 1 retail pack",
      snacks: popularSnackOptionsRetail,
    },
    {
      type: "checkbox",
      variantIds: [42107179139142],
      qty: 1,
      maxChecked: 2,
      name: "Snackie Cases",
      label: "Choose 2 Snackie Cases",
      snacks: snackieBoxOptions,
    },
    // Bloom Box - Brillant
    {
      type: "checkbox",
      variantIds: [44081028038726],
      qty: 1,
      maxChecked: 1,
      name: "Retail pack",
      label: "Choose 1 retail pack",
      snacks: popularSnackOptionsRetail,
    },
    {
      type: "checkbox",
      variantIds: [44081028038726],
      qty: 1,
      maxChecked: 4,
      name: "Goodie Cases",
      label: "Choose up to 4 Goodie Cases",
      tooltip: "We will apportion your selected flavours equally",
      snacks: goodieBoxOptions,
    },
    // Bloom Box - Blossom
    {
      type: "checkbox",
      variantIds: [44081028071494],
      qty: 1,
      maxChecked: 4,
      name: "Snackie Cases",
      label: "Choose up to 4 Snackie Cases",
      tooltip: "We will apportion your selected flavours equally",
      snacks: snackieBoxOptions,
    },
    // Bloom Box - Breathtaking
    {
      type: "display",
      variantIds: [44331604574278],
      html: `
      Four Premium Nuts Snackie cases included
      <ol>
        <li>Honey Brainy Pecans 220g</li>
        <li>Abalone Creamy Macadamia 220g</li>
        <li>Power Baked Pistachio Kernels 250g</li>
        <li>Xmas Pine Nuts 250g</li>
      </ol>
      `
    },
    // Harvest Box - Spring
    {
      type: "checkbox",
      variantIds: [44081028169798],
      qty: 1,
      maxChecked: 1,
      name: "Retail Packs",
      label: "Choose a retail pack",
      snacks: popularSnackOptionsRetail,
    },
    // Harvest Box - Summer 
    {
      type: "checkbox",
      variantIds: [44081028202566],
      qty: 1,
      maxChecked: 1,
      name: "Snackie Cases",
      label: "Choose 2 Snackie Cases",
      snacks: snackieBoxOptions,
    },
    // Harvest Box - Autumn 
    {
      type: "checkbox",
      variantIds: [44081028235334],
      qty: 1,
      maxChecked: 1,
      name: "Snackie Case",
      label: "Choose a Snackie Case",
      snacks: snackieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [44081028235334],
      qty: 1,
      maxChecked: 2,
      name: "Goodie Cases",
      label: "Choose 2 Goodie Cases",
      snacks: goodieBoxOptions,
    },
    // Harvest Box - Winter 
    {
      type: "checkbox",
      variantIds: [44081028268102],
      qty: 1,
      maxChecked: 4,
      name: "Goodie Cases",
      label: "Choose 4 Goodie Cases",
      snacks: goodieBoxOptions,
    },
    // Rosy Set - Cute
    {
      type: "checkbox",
      variantIds: [44081028366406],
      qty: 1,
      maxChecked: 3,
      name: "Party Packs",
      label: "Choose 3 Biscuits Party Packs",
      snacks: biscuitOptionsParty,
    },
    // Rosy Set - Care
    {
      type: "checkbox",
      variantIds: [44081028399174],
      qty: 1,
      maxChecked: 3,
      name: "Party Packs",
      label: "Choose 3 Nuts and Snacks Party Packs",
      snacks: popularSnackOptionsParty,
    },
    // Rosy Set - Cheer
    {
      type: "checkbox",
      variantIds: [44081028431942],
      qty: 1,
      maxChecked: 1,
      name: "Snackie Case",
      label: "Choose a Snackie Case",
      snacks: snackieBoxOptions,
    },
    // Rosy Set - Comfort
    {
      type: "checkbox",
      variantIds: [44081028464710],
      qty: 1,
      maxChecked: 2,
      name: "Goodie Case",
      label: "Choose 2 Goodie Cases",
      snacks: goodieBoxOptions,
    },
    // Blossom - Tri Core
    {
      type: "checkbox",
      variantIds: [44794545733702],
      qty: 1,
      maxChecked: 3,
      name: "Gift Packs",
      label: "Choose Nuts and Snacks Flavours",
      snacks: popularSnackOptionsGift,
    },
    // Blossom - Clarity
    {
      type: "checkbox",
      variantIds: [44794545766470],
      qty: 1,
      maxChecked: 6,
      name: "Party Packs",
      label: "Choose Nuts and Snacks Flavours",
      snacks: popularSnackOptionsParty,
    },
    {
      type: "checkbox",
      variantIds: [44794545766470],
      qty: 1,
      maxChecked: 6,
      name: "Tea sachet",
      label: "Choose Tea Flavours",
      snacks: teaPartyPackOptions,
    },
    // Blossom - Tranquility
    {
      type: "checkbox",
      variantIds: [44794545799238],
      qty: 1,
      maxChecked: 8,
      name: "Party Packs",
      label: "Choose Nuts and Snacks Flavours",
      tooltip: "We will apportion your snacks equally",
      snacks: popularSnackOptionsParty,
    },
    {
      type: "checkbox",
      variantIds: [44794545799238],
      qty: 1,
      maxChecked: 8,
      name: "Tea sachet",
      label: "Choose Tea Flavours",
      tooltip: "We will apportion your snacks equally",
      snacks: teaPartyPackOptions,
    },
    // Blossom - Glow Refresh
    {
      type: "checkbox",
      variantIds: [44794545832006],
      qty: 1,
      maxChecked: 4,
      name: "Party Packs",
      label: "Choose Nuts and Snacks Flavours",
      tooltip: "We will apportion your snacks equally",
      snacks: popularSnackOptionsParty,
    },
    {
      type: "checkbox",
      variantIds: [44794545832006],
      qty: 1,
      maxChecked: 4,
      name: "Tea sachet",
      label: "Choose Tea Flavours",
      tooltip: "We will apportion your snacks equally",
      snacks: teaPartyPackOptions,
    },
    {
      type: "checkbox",
      variantIds: [44794545832006],
      qty: 1,
      maxChecked: 4,
      name: "Honey sachet",
      label: "Choose Honey Flavours",
      tooltip: "We will apportion your snacks equally",
      snacks: honeyPartyPackOptions,
    },
    // Blossom - Glow Revive
    {
      type: "checkbox",
      variantIds: [44794545864774],
      qty: 1,
      maxChecked: 6,
      name: "Party Packs",
      label: "Choose Nuts and Snacks Flavours",
      tooltip: "We will apportion your snacks equally",
      snacks: popularSnackOptionsParty,
    },
    {
      type: "checkbox",
      variantIds: [44794545864774],
      qty: 1,
      maxChecked: 4,
      name: "Tea sachet",
      label: "Choose Tea Flavours",
      tooltip: "We will apportion your snacks equally",
      snacks: teaPartyPackOptions,
    },
    {
      type: "checkbox",
      variantIds: [44794545864774],
      qty: 1,
      maxChecked: 4,
      name: "Honey sachet",
      label: "Choose Honey Flavours",
      tooltip: "We will apportion your snacks equally",
      snacks: honeyPartyPackOptions,
    },
    // Flourish - duo core
    {
      type: "checkbox",
      variantIds: [44794530463814],
      qty: 1,
      maxChecked: 2,
      name: "Gift Packs",
      label: "Choose 2 gift packs",
      tooltip: "We will apportion your selected flavours equally",
      snacks: popularSnackOptionsGift,
    },
    // Flourish - divine harmony
    {
      type: "checkbox",
      variantIds: [44794530496582],
      qty: 1,
      maxChecked: 2,
      name: "Party Packs",
      label: "Choose 2 Nuts and Snacks Flavours",
      tooltip: "We will apportion your snacks equally",
      snacks: popularSnackOptionsParty,
    },
    {
      type: "checkbox",
      variantIds: [44794530496582],
      qty: 1,
      maxChecked: 2,
      name: "Tea sachet",
      label: "Choose 2 Tea Flavours",
      tooltip: "We will apportion your snacks equally",
      snacks: teaPartyPackOptions,
    },
    // Flourish - divine wellness
    {
      type: "checkbox",
      variantIds: [44794530529350],
      qty: 1,
      maxChecked: 4,
      name: "Party Packs",
      label: "Choose 4 Nuts and Snacks Flavours",
      tooltip: "We will apportion your snacks equally",
      snacks: popularSnackOptionsParty,
    },
    {
      type: "checkbox",
      variantIds: [44794530529350],
      qty: 1,
      maxChecked: 4,
      name: "Tea sachet",
      label: "Choose 4 Tea Flavours",
      tooltip: "We will apportion your snacks equally",
      snacks: teaPartyPackOptions,
    },
    // Flourish - glow relax
    {
      type: "checkbox",
      variantIds: [44794530562118],
      qty: 1,
      maxChecked: 2,
      name: "Party Packs",
      label: "Choose 2 Nuts and Snacks Flavours",
      tooltip: "We will apportion your snacks equally",
      snacks: popularSnackOptionsParty,
    },
    {
      type: "checkbox",
      variantIds: [44794530562118],
      qty: 1,
      maxChecked: 2,
      name: "Tea sachet",
      label: "Choose 2 Tea Flavours",
      tooltip: "We will apportion your snacks equally",
      snacks: teaPartyPackOptions,
    },
    {
      type: "checkbox",
      variantIds: [44794530562118],
      qty: 1,
      maxChecked: 2,
      name: "Honey sachet",
      label: "Choose Honey Flavours",
      tooltip: "We will apportion your snacks equally",
      snacks: honeyPartyPackOptions,
    },
    // Flourish - glow recharge
    {
      type: "checkbox",
      variantIds: [44794530594886],
      qty: 1,
      maxChecked: 3,
      name: "Party Packs",
      label: "Choose 3 Nuts and Snacks Flavours",
      tooltip: "We will apportion your snacks equally",
      snacks: popularSnackOptionsParty,
    },
    {
      type: "checkbox",
      variantIds: [44794530594886],
      qty: 1,
      maxChecked: 3,
      name: "Tea sachet",
      label: "Choose 3 Tea Flavours",
      tooltip: "We will apportion your snacks equally",
      snacks: teaPartyPackOptions,
    },
    {
      type: "checkbox",
      variantIds: [44794530594886],
      qty: 1,
      maxChecked: 3,
      name: "Honey sachet",
      label: "Choose Honey Flavours",
      tooltip: "We will apportion your snacks equally",
      snacks: honeyPartyPackOptions,
    },
  ],
  "curated-snacks-custom-drinks-box-and-hamper": [
    {
      type: "checkbox",
      variantIds: [43457860796486],
      qty: 1,
      maxChecked: 1,
      name: "Party Packs",
      label: "Choose 4 Party Packs",
      snacks: popularSnackOptionsParty,
    },
    {
      type: "select",
      variantIds: [43457860796486],
      qty: 1,
      maxChecked: 1,
      name: "Drink",
      label: "Choose a drink",
      snacks: remedyOptions.concat(sodalyOptions),
    },
    {
      type: "select",
      variantIds: [39443911180358, 39287456890950, 39549578838086, 39287456923718],
      qty: 1,
      name: "Drink",
      label: "Select your drink",
      snacks: popularDrinkOptions,
    },
    {
      type: "select",
      variantIds: [39443911180358, 39287456890950, 39549578838086, 39287456923718],
      qty: 1,
      name: "Drink",
      label: "Select your drink",
      snacks: popularDrinkOptions,
    },
    {
      type: "select",
      variantIds: [39443911180358, 39287456890950, 39549578838086, 39287456923718],
      qty: 1,
      name: "Drink",
      label: "Select your drink",
      snacks: popularDrinkOptions,
    },
    {
      type: "select",
      variantIds: [39299615162438, 40161237663814],
      qty: 2,
      name: "Drink",
      label: "Select your drinks",
      snacks: popularDrinkOptions,
    },
  ],
  "nut-drink-rude-health": [
    {
      type: "checkbox",
      variantIds: [39814485278790],
      qty: 1,
      maxChecked: 2,
      name: "Flavours",
      label: "Flavours (You can mix and match)",
      tooltip: "We will apportion your selected flavours equally",
      snacks: rudeHealthOptions,
    },
    {
      type: "checkbox",
      variantIds: [39814485311558],
      qty: 1,
      maxChecked: 6,
      name: "Flavours",
      label: "Flavours (You can mix and match)",
      tooltip: "We will apportion your selected flavours equally",
      snacks: rudeHealthOptions,
    },
  ],
  "dash-sparkling-water": [
    {
      type: "checkbox",
      variantIds: [39355585462342, 39355585495110, 39408525541446],
      qty: 1,
      name: "Flavours",
      label: "Flavours (You can mix and match)",
      tooltip: "We will apportion your selected flavours equally",
      snacks: dashOptions,
    },
  ],
  "sodaly-prebiotic-soda": [
    {
      type: "checkbox",
      variantIds: [42310395232326, 42310395265094, 42310395297862],
      qty: 1,
      name: "Flavours",
      label: "Flavours (You can mix and match)",
      tooltip: "We will apportion your selected flavours equally",
      snacks: sodalyOptions,
    },
  ],
  "remedy-kombucha": [
    {
      type: "checkbox",
      variantIds: [39362966650950, 39408514334790, 39444732772422],
      qty: 1,
      name: "Flavours",
      label: "Flavours (You can mix and match)",
      tooltip: "We will apportion your selected flavours equally",
      snacks: remedyOptions,
    },
  ],
  "gryphon-tea": [
    {
      type: "checkbox",
      variantIds: [39411219103814],
      qty: 1,
      maxChecked: 3,
      name: "Flavours",
      label: "Flavours (You can mix and match)",
      tooltip: "We will apportion your selected flavours equally",
      snacks: gryphonOptions,
    },
    {
      type: "checkbox",
      variantIds: [39411219136582, 39411219202118],
      qty: 1,
      name: "Flavours",
      label: "Flavours (You can mix and match)",
      tooltip: "We will apportion your selected flavours equally",
      snacks: gryphonOptions,
    },
  ],
  "xmas-snack-gift": [
    // Magical
    {
      type: "display",
      variantIds: [43455986073670],
      html: `Included in the package
          <ol style="padding: 1rem">
            <li>Sweet Mustard Soya Crisps 150g</li>
            <li>Supreme Popular Medley 200g</li>
            <li>Worthy Pecans Chocolate Chips Cookies in Snackie Case 150g</li>
            <li>Worthy Ondeh Ondeh Cookies in Snackie Case 150g</li>
            <li>Gingerbread Cookie</li>
            <li>Sour Candies Bear Bottle</li>
            <li>Mini Borsari Classic Panettone</li>
          </ol>
          `,
    },
    // Angelic
    {
      type: "checkbox",
      variantIds: [43870525456454],
      maxChecked: 2,
      qty: 1,
      name: "Snackie Cases",
      label: "Choose 2 Snackie Cases",
      snacks: xmasSnackieOptions,
    },
    {
      type: "display",
      variantIds: [43870525456454],
      html: `Included in the package
          <ol style="padding: 1rem">
            <li>Merry Gift Set (Supreme Hearty Medley, Cocoa Power Medley and Supreme Honey Medley)</li>
            <li>Gingerbread Cookie</li>
            <li>Sour Candies Bear Bottle</li>
            <li>Mini Borsari Classic Panettone</li>
          </ol>
          `,
    },
    // Wonder
    {
      type: "checkbox",
      variantIds: [43455986106438],
      maxChecked: 2,
      qty: 1,
      name: "Retail Packs",
      label: "Choose 2 Retail Packs",
      snacks: popularSnackOptionsRetail,
    },
    {
      type: "checkbox",
      variantIds: [43455986106438],
      maxChecked: 4,
      qty: 1,
      name: "Snackie Cases",
      label: "Choose 4 Snackie Cases",
      snacks: xmasSnackieOptions,
    },
    {
      type: "display",
      variantIds: [43455986106438],
      html: `Included in the package
          <ol style="padding: 1rem">
            <li>Snack Keychain Blind Boxes</li>
            <li>Merry Gift Set (Supreme Hearty Medley, Cocoa Power Medley and Supreme Honey Medley)</li>
            <li>Gingerbread Cookie</li>
            <li>Sour Candies Bear Bottle</li>
            <li>Mini Borsari Classic Panettone</li>
          </ol>
          `,
    },
    // Bonaza
    {
      type: "checkbox",
      variantIds: [43455986565190],
      maxChecked: 3,
      qty: 1,
      name: "Retail Packs",
      label: "Choose 3 Retail Packs",
      snacks: popularSnackOptionsRetail,
    },
    {
      type: "checkbox",
      variantIds: [43455986565190],
      maxChecked: 4,
      qty: 1,
      name: "Snackie Cases",
      label: "Choose 4 Snackie Cases",
      snacks: xmasSnackieOptions,
    },
    {
      type: "display",
      variantIds: [43455986565190],
      html: `Included in the package
          <ol style="padding: 1rem">
            <li>Two Snack Keychain Blind Boxes</li>
            <li>Merry Gift Set (Supreme Hearty Medley, Cocoa Power Medley and Supreme Honey Medley)</li>
            <li>Two Gingerbread Cookies</li>
            <li>Sour Candies Bear Bottle</li>
            <li>Mini Borsari Classic Panettone</li>
            <li>Mini Borsari Pistachio Panettone</li>
          </ol>
          `,
    },
    // all variants
    {
      type: "select",
      variantIds: [43455986073670, 43870525456454, 43455986106438, 43455986565190],
      qty: 1,
      name: "Sticker design",
      label: "Select your sticker design",
      snacks: hamperStickerOptions,
    },
    {
      type: "hamperDatePicker",
      variantIds: [43455986073670, 43870525456454, 43455986106438, 43455986565190],
    },
    {
      type: "textField",
      variantIds: [43455986073670, 43870525456454, 43455986106438, 43455986565190],
      name: "Message",
      label: "Your message on card (optional)",
    },
  ],
  "cny-snack-box": [
    // Fortune
    {
      type: "display",
      variantIds: [44048200597574],
      html: `Included in the package
          <ul style="padding: 1rem">
            <li>Chunky Peanut Cookies 150g</li>
            <li>Satay Crunch Cashews 200g</li>
            <li>2 Snackie Cases</li>
            <ol>
              <li>Supreme Popular Medley</li>
              <li>Sambal Shrimp Rolls</li>
            </ol>
            <li>Heng Ong Huat Gift Set of 3 flavours</li>
            <ol>
              <li>Oishi Japanese Nuts Medley</li>
              <li>Floral Pineapple Tarts</li>
              <li>Sunkissed Roasted Cashews</li>
            </ol>
          </ul>
          `,
    },
    // Abundance
    {
      type: "display",
      variantIds: [44048200892486],
      html: `Included in the package
          <ul style="padding: 1rem">
            <li>Chunky Peanut Cookies 150g</li>
            <li>Satay Crunch Cashews 200g</li>
            <li>4 Snackie Cases</li>
            <ol>
              <li>Abalone Macadamias</li>
              <li>Supreme Popular Medley</li>
              <li>Baked Pistachios</li>
              <li>Sambal Shrimp Rolls</li>
            </ol>
            <li>Heng Ong Huat Gift Set of 3 flavours</li>
            <ol>
              <li>Oishi Japanese Nuts Medley</li>
              <li>Floral Pineapple Tarts</li>
              <li>Sunkissed Roasted Cashews</li>
            </ol>
          </ul>
          `,
    },
    // Prosperity
    {
      type: "display",
      variantIds: [42193622532166],
      html: `Included in the package
          <ul style="padding: 1rem">
            <li>Chunky Peanut Cookies 150g</li>
            <li>Satay Crunch Cashews 200g</li>
            <li>Ong Penapple Tarts 350g</li>
            <li>Huat Penapple Tarts 350g</li>
            <li>6 Snackie Cases</li>
            <ol>
              <li>Abalone Macadamias</li>
              <li>Kumquat Cookies</li>
              <li>Supreme Popular Medley</li>
              <li>Baked Pistachios</li>
              <li>Sambal Shrimp Rolls</li>
            </ol>
            <li>Fu Shou An Kang Gift Set of 4 flavours</li>
            <ol>
              <li>Sour Candies Medley</li>
              <li>Kacang Puteh Medley</li>
              <li>Nihon Seaweed Peanuts</li>
              <li>Worthy Osmanthus Cookies</li>
            </ol>
            <li>Flower Mushroom Gift Set</li>
          </ul>
          `,
    },
    // Longevity
    {
      type: "display",
      variantIds: [42193622564934],
      html: `Included in the package
          <ul style="padding: 1rem">
            <li>Chunky Peanut Cookies 150g</li>
            <li>Satay Crunch Cashews 200g</li>
            <li>Huat Penapple Tarts 350g</li>
            <li>6 Snackie Cases</li>
            <ol>
              <li>Premium Japanese Dried Scallops</li>
              <li>Kumquat Cookies</li>
              <li>Supreme Popular Medley</li>
              <li>Baked Pistachios</li>
              <li>Abalone Macadamias</li>
              <li>Sambal Shrimp Rolls</li>
            </ol>
            <li>Fu Shou An Kang Gift Set of 4 flavours</li>
            <ol>
              <li>Sour Candies Medley</li>
              <li>Kacang Puteh Medley</li>
              <li>Nihon Seaweed Peanuts</li>
              <li>Worthy Osmanthus Cookies</li>
            </ol>
            <li>Flower Mushroom Gift Set</li>
          </ul>
          `,
    },
    // all hamper variants
    {
      type: "hamperDatePicker",
      variantIds: [44048200597574, 44048200892486, 42193622532166, 42193622564934],
    },
    {
      type: "textField",
      variantIds: [44048200597574, 44048200892486, 42193622532166, 42193622564934],
      name: "Message",
      label: "Your message on card (optional)",
    },
  ],
  "anniversary-snack-hampers": [ 
    // Shine
    {
      type: "checkbox",
      variantIds: [44957574660166],
      maxChecked: 1,
      qty: 2,
      name: "Tea Pouch",
      label: "Choose 2 Tea Flavours",
      snacks: teaPouchOptions,
    },
    {
      type: "checkbox",
      variantIds: [44957574660166],
      maxChecked: 1,
      qty: 1,
      name: "Snackie Case",
      label: "Choose a Snackie Case",
      snacks: snackieBoxOptions,
    },
    // Radiance
    {
      type: "checkbox",
      variantIds: [44957574692934],
      maxChecked: 1,
      qty: 1,
      name: "Tea Pouch",
      label: "Choose 2 Tea Flavours",
      snacks: teaPouchOptions,
    },
    {
      type: "checkbox",
      variantIds: [44957574692934],
      maxChecked: 1,
      qty: 1,
      name: "Snackie Case",
      label: "Choose 2 Snackie Cases",
      snacks: snackieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [44957574692934],
      maxChecked: 1,
      qty: 1,
      name: "Crystie Bottle",
      label: "Choose a Crystie Bottle",
      snacks: crystieOptions,
    },
    // Brillance
    {
      type: "checkbox",
      variantIds: [44957574725702],
      maxChecked: 2,
      qty: 1,
      name: "Tea Pouch",
      label: "Choose 3 Tea Flavours",
      snacks: teaPouchOptions,
    },
    {
      type: "checkbox",
      variantIds: [44957574725702],
      maxChecked: 3,
      qty: 1,
      name: "Snackie Case",
      label: "Choose 3 Snackie Cases",
      snacks: snackieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [44957574725702],
      maxChecked: 2,
      qty: 1,
      name: "Crystie Bottle",
      label: "Choose 2 Crystie Bottles",
      snacks: crystieOptions,
    },
    // Twinkles
    {
      type: "checkbox",
      variantIds: [44957574758470],
      maxChecked: 4,
      qty: 1,
      name: "Tea Pouch",
      label: "Choose 4 Tea Flavours",
      snacks: teaPouchOptions,
    },
    {
      type: "checkbox",
      variantIds: [44957574758470],
      maxChecked: 4,
      qty: 1,
      name: "Snackie Case",
      label: "Choose 4 Snackie Cases",
      snacks: snackieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [44957574758470],
      maxChecked: 3,
      qty: 1,
      name: "Crystie Bottle",
      label: "Choose 3 Crystie Bottles",
      snacks: crystieOptions,
    },
    // all variants
    {
      type: "select",
      variantIds: [44957574660166, 44957574692934, 44957574725702, 44957574758470],
      qty: 1,
      name: "Sticker design",
      label: "Select your sticker design",
      snacks: hamperStickerOptions,
    },
    {
      type: "hamperDatePicker",
      variantIds: [44957574660166, 44957574692934, 44957574725702, 44957574758470],
    },
    {
      type: "textField",
      variantIds: [44957574660166, 44957574692934, 44957574725702, 44957574758470],
      name: "Message",
      label: "Your message on card (optional)",
    },
  ],
  "housewarming-snack-hampers": [ 
    // Shine
    {
      type: "checkbox",
      variantIds: [43675724709958],
      maxChecked: 1,
      qty: 2,
      name: "Tea Pouch",
      label: "Choose 2 Tea Flavours",
      snacks: teaPouchOptions,
    },
    {
      type: "checkbox",
      variantIds: [43675724709958],
      maxChecked: 1,
      qty: 1,
      name: "Snackie Case",
      label: "Choose a Snackie Case",
      snacks: snackieBoxOptions,
    },
    // Radiance
    {
      type: "checkbox",
      variantIds: [43675724742726],
      maxChecked: 1,
      qty: 1,
      name: "Tea Pouch",
      label: "Choose 2 Tea Flavours",
      snacks: teaPouchOptions,
    },
    {
      type: "checkbox",
      variantIds: [43675724742726],
      maxChecked: 1,
      qty: 1,
      name: "Snackie Case",
      label: "Choose 2 Snackie Cases",
      snacks: snackieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [43675724742726],
      maxChecked: 1,
      qty: 1,
      name: "Crystie Bottle",
      label: "Choose a Crystie Bottle",
      snacks: crystieOptions,
    },
    // Brillance
    {
      type: "checkbox",
      variantIds: [43675724775494],
      maxChecked: 2,
      qty: 1,
      name: "Tea Pouch",
      label: "Choose 3 Tea Flavours",
      snacks: teaPouchOptions,
    },
    {
      type: "checkbox",
      variantIds: [43675724775494],
      maxChecked: 3,
      qty: 1,
      name: "Snackie Case",
      label: "Choose 3 Snackie Cases",
      snacks: snackieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [43675724775494],
      maxChecked: 2,
      qty: 1,
      name: "Crystie Bottle",
      label: "Choose 2 Crystie Bottles",
      snacks: crystieOptions,
    },
    // Twinkles
    {
      type: "checkbox",
      variantIds: [43675724808262],
      maxChecked: 4,
      qty: 1,
      name: "Tea Pouch",
      label: "Choose 4 Tea Flavours",
      snacks: teaPouchOptions,
    },
    {
      type: "checkbox",
      variantIds: [43675724808262],
      maxChecked: 4,
      qty: 1,
      name: "Snackie Case",
      label: "Choose 4 Snackie Cases",
      snacks: snackieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [43675724808262],
      maxChecked: 3,
      qty: 1,
      name: "Crystie Bottle",
      label: "Choose 3 Crystie Bottles",
      snacks: crystieOptions,
    },
    // all variants
    {
      type: "select",
      variantIds: [43675724709958, 43675724742726, 43675724775494, 43675724808262],
      qty: 1,
      name: "Sticker design",
      label: "Select your sticker design",
      snacks: hamperStickerOptions,
    },
    {
      type: "hamperDatePicker",
      variantIds: [43675724709958, 43675724742726, 43675724775494, 43675724808262],
    },
    {
      type: "textField",
      variantIds: [43675724709958, 43675724742726, 43675724775494, 43675724808262],
      name: "Message",
      label: "Your message on card (optional)",
    },
  ],
  "newborn-new-mum-hampers": [
    // Dainty
    {
      type: "checkbox",
      variantIds: [44956568977478],
      maxChecked: 1,
      qty: 1,
      name: "Tea",
      label: "Choose a Tea Flavour",
      snacks: teaPouchOptions,
    },
    {
      type: "checkbox",
      variantIds: [44956568977478],
      maxChecked: 1,
      qty: 1,
      name: "Snackie Cases",
      label: "Choose a Snackie Case",
      snacks: snackieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [44956568977478],
      maxChecked: 1,
      qty: 1,
      name: "Crystie Bottles",
      label: "Choose a Crystie Bottle",
      snacks: crystieOptions,
    },
    // Lush
    {
      type: "checkbox",
      variantIds: [44956569010246],
      maxChecked: 1,
      qty: 1,
      name: "Tea",
      label: "Choose a Tea Flavour",
      snacks: teaPouchOptions,
    },
    {
      type: "checkbox",
      variantIds: [44956569010246],
      maxChecked: 2,
      qty: 1,
      name: "Snackie Cases",
      label: "Choose 2 Snackie Cases",
      snacks: snackieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [44956569010246],
      maxChecked: 1,
      qty: 1,
      name: "Crystie Bottles",
      label: "Choose a Crystie Bottle",
      snacks: crystieOptions,
    },
    // Vibrant
    {
      type: "checkbox",
      variantIds: [44956569043014],
      maxChecked: 1,
      qty: 1,
      name: "Tea",
      label: "Choose 2 Tea Flavours",
      snacks: teaPouchOptions,
    },
    {
      type: "checkbox",
      variantIds: [44956569043014],
      maxChecked: 3,
      qty: 1,
      name: "Snackie Cases",
      label: "Choose 3 Snackie Cases",
      snacks: snackieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [44956569043014],
      maxChecked: 2,
      qty: 1,
      name: "Crystie Bottles",
      label: "Choose 2 Crystie Bottles",
      snacks: crystieOptions,
    },
    // Whimsical
    {
      type: "checkbox",
      variantIds: [44956569075782],
      maxChecked: 2,
      qty: 1,
      name: "Tea",
      label: "Choose 2 Tea Flavours",
      snacks: teaPouchOptions,
    },
    {
      type: "checkbox",
      variantIds: [44956569075782],
      maxChecked: 4,
      qty: 1,
      name: "Snackie Cases",
      label: "Choose 4 Snackie Cases",
      snacks: snackieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [44956569075782],
      maxChecked: 4,
      qty: 1,
      name: "Crystie Bottles",
      label: "Choose 4 Crystie Bottles",
      snacks: crystieOptions,
    },
    // all variants
    {
      type: "select",
      variantIds: [44956568977478, 44956569010246, 44956569043014, 44956569075782],
      qty: 1,
      name: "Sticker design",
      label: "Select your sticker design",
      snacks: hamperStickerOptions,
    },
    {
      type: "hamperDatePicker",
      variantIds: [44956568977478, 44956569010246, 44956569043014, 44956569075782],
    },
    {
      type: "textField",
      variantIds: [44956568977478, 44956569010246, 44956569043014, 44956569075782],
      name: "Message",
      label: "Your message on card (optional)",
    },
  ],
  "happy-snacking-hampers": [
    // Bash
    {
      type: "checkbox",
      variantIds: [41944042045510],
      maxChecked: 4,
      qty: 1,
      name: "Retail Packs",
      label: "Choose 4 Retail Packs",
      snacks: popularSnackOptionsRetail,
    },
    {
      type: "checkbox",
      variantIds: [41944042045510],
      maxChecked: 4,
      qty: 1,
      name: "Goodie Cases",
      label: "Choose 4 Goodie Cases",
      snacks: goodieBoxOptions,
    },
    // Party
    {
      type: "checkbox",
      variantIds: [41944042078278],
      maxChecked: 4,
      qty: 1,
      name: "Retail Packs",
      label: "Choose 4 Retail Packs",
      snacks: popularSnackOptionsRetail,
    },
    {
      type: "checkbox",
      variantIds: [41944042078278],
      maxChecked: 4,
      qty: 1,
      name: "Snackie Cases",
      label: "Choose 4 Snackie Cases",
      snacks: snackieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [41944042078278],
      maxChecked: 2,
      qty: 1,
      name: "Goodie Cases",
      label: "Choose 2 Goodie Cases",
      snacks: goodieBoxOptions,
    },
    // Gathering
    {
      type: "checkbox",
      variantIds: [41944042111046],
      maxChecked: 4,
      qty: 1,
      name: "Retail Packs",
      label: "Choose 4 Retail Packs",
      snacks: popularSnackOptionsRetail,
    },
    {
      type: "checkbox",
      variantIds: [41944042111046],
      maxChecked: 4,
      qty: 1,
      name: "Snackie Cases",
      label: "Choose 4 Snackie Cases",
      snacks: snackieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [41944042111046],
      maxChecked: 4,
      qty: 1,
      name: "Goodie Cases",
      label: "Choose 4 Goodie Cases",
      snacks: goodieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [41944042111046],
      maxChecked: 2,
      qty: 1,
      name: "Crystie Bottles",
      label: "Choose 2 Crystie Bottles",
      snacks: crystieOptions,
    },
    // Celebration
    {
      type: "checkbox",
      variantIds: [41944042143814],
      maxChecked: 4,
      qty: 1,
      name: "Retail Packs",
      label: "Choose 4 Retail Packs",
      snacks: popularSnackOptionsRetail,
    },
    {
      type: "checkbox",
      variantIds: [41944042143814],
      maxChecked: 4,
      qty: 1,
      name: "Snackie Cases",
      label: "Choose 4 Snackie Cases",
      snacks: snackieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [41944042143814],
      maxChecked: 4,
      qty: 1,
      name: "Goodie Cases",
      label: "Choose 4 Goodie Cases",
      snacks: goodieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [41944042143814],
      maxChecked: 5,
      qty: 1,
      name: "Crystie Bottles",
      label: "Choose 5 Crystie Bottles",
      snacks: crystieOptions,
    },
    // all variants
    {
      type: "select",
      variantIds: [41944042045510, 41944042078278, 41944042111046, 41944042143814],
      qty: 1,
      name: "Sticker design",
      label: "Select your sticker design",
      snacks: hamperStickerOptions,
    },
    {
      type: "hamperDatePicker",
      variantIds: [41944042045510, 41944042078278, 41944042111046, 41944042143814],
    },
    {
      type: "textField",
      variantIds: [41944042045510, 41944042078278, 41944042111046, 41944042143814],
      name: "Message",
      label: "Your message on card (optional)",
    },
  ],
  "snack-hampers": [
    // Bash
    {
      type: "checkbox",
      variantIds: [42205317333062],
      maxChecked: 4,
      qty: 1,
      name: "Retail Packs",
      label: "Choose 4 Retail Packs",
      snacks: popularSnackOptionsRetail,
    },
    {
      type: "checkbox",
      variantIds: [42205317333062],
      maxChecked: 4,
      qty: 1,
      name: "Goodie Cases",
      label: "Choose 4 Goodie Cases",
      snacks: goodieBoxOptions,
    },
    // Party
    {
      type: "checkbox",
      variantIds: [42201035505734],
      maxChecked: 4,
      qty: 1,
      name: "Retail Packs",
      label: "Choose 4 Retail Packs",
      snacks: popularSnackOptionsRetail,
    },
    {
      type: "checkbox",
      variantIds: [42201035505734],
      maxChecked: 4,
      qty: 1,
      name: "Snackie Cases",
      label: "Choose 4 Snackie Cases",
      snacks: snackieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [42201035505734],
      maxChecked: 2,
      qty: 1,
      name: "Goodie Cases",
      label: "Choose 2 Goodie Cases",
      snacks: goodieBoxOptions,
    },
    // Gathering
    {
      type: "checkbox",
      variantIds: [42201033080902],
      maxChecked: 4,
      qty: 1,
      name: "Retail Packs",
      label: "Choose 4 Retail Packs",
      snacks: popularSnackOptionsRetail,
    },
    {
      type: "checkbox",
      variantIds: [42201033080902],
      maxChecked: 4,
      qty: 1,
      name: "Snackie Cases",
      label: "Choose 4 Snackie Cases",
      snacks: snackieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [42201033080902],
      maxChecked: 4,
      qty: 1,
      name: "Goodie Cases",
      label: "Choose 4 Goodie Cases",
      snacks: goodieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [42201033080902],
      maxChecked: 2,
      qty: 1,
      name: "Crystie Bottles",
      label: "Choose 2 Crystie Bottles",
      snacks: crystieOptions,
    },
    // Celebration
    {
      type: "checkbox",
      variantIds: [42205317431366],
      maxChecked: 4,
      qty: 1,
      name: "Retail Packs",
      label: "Choose 4 Retail Packs",
      snacks: popularSnackOptionsRetail,
    },
    {
      type: "checkbox",
      variantIds: [42205317431366],
      maxChecked: 4,
      qty: 1,
      name: "Snackie Cases",
      label: "Choose 4 Snackie Cases",
      snacks: snackieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [42205317431366],
      maxChecked: 4,
      qty: 1,
      name: "Goodie Cases",
      label: "Choose 4 Goodie Cases",
      snacks: goodieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [42205317431366],
      maxChecked: 5,
      qty: 1,
      name: "Crystie Bottles",
      label: "Choose 5 Crystie Bottles",
      snacks: crystieOptions,
    },
    // all variants
    {
      type: "select",
      variantIds: [42205317333062, 42201035505734, 42201033080902, 42205317431366],
      qty: 1,
      name: "Sticker design",
      label: "Select your sticker design",
      snacks: hamperStickerOptions,
    },
    {
      type: "hamperDatePicker",
      variantIds: [42205317333062, 42201035505734, 42201033080902, 42205317431366],
    },
    {
      type: "textField",
      variantIds: [42205317333062, 42201035505734, 42201033080902, 42205317431366],
      name: "Message",
      label: "Your message on card (optional)",
    },
  ],
  "happy-graduation-all-snacks-hampers": [
    // Bash
    {
      type: "checkbox",
      variantIds: [44956805693510],
      maxChecked: 4,
      qty: 1,
      name: "Retail Packs",
      label: "Choose 4 Retail Packs",
      snacks: popularSnackOptionsRetail,
    },
    {
      type: "checkbox",
      variantIds: [44956805693510],
      maxChecked: 4,
      qty: 1,
      name: "Goodie Cases",
      label: "Choose 4 Goodie Cases",
      snacks: goodieBoxOptions,
    },
    // Party
    {
      type: "checkbox",
      variantIds: [44956805726278],
      maxChecked: 4,
      qty: 1,
      name: "Retail Packs",
      label: "Choose 4 Retail Packs",
      snacks: popularSnackOptionsRetail,
    },
    {
      type: "checkbox",
      variantIds: [44956805726278],
      maxChecked: 4,
      qty: 1,
      name: "Snackie Cases",
      label: "Choose 4 Snackie Cases",
      snacks: snackieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [44956805726278],
      maxChecked: 2,
      qty: 1,
      name: "Goodie Cases",
      label: "Choose 2 Goodie Cases",
      snacks: goodieBoxOptions,
    },
    // Gathering
    {
      type: "checkbox",
      variantIds: [44956805759046],
      maxChecked: 4,
      qty: 1,
      name: "Retail Packs",
      label: "Choose 4 Retail Packs",
      snacks: popularSnackOptionsRetail,
    },
    {
      type: "checkbox",
      variantIds: [44956805759046],
      maxChecked: 4,
      qty: 1,
      name: "Snackie Cases",
      label: "Choose 4 Snackie Cases",
      snacks: snackieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [44956805759046],
      maxChecked: 4,
      qty: 1,
      name: "Goodie Cases",
      label: "Choose 4 Goodie Cases",
      snacks: goodieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [44956805759046],
      maxChecked: 2,
      qty: 1,
      name: "Crystie Bottles",
      label: "Choose 2 Crystie Bottles",
      snacks: crystieOptions,
    },
    // Celebration
    {
      type: "checkbox",
      variantIds: [44956805791814],
      maxChecked: 4,
      qty: 1,
      name: "Retail Packs",
      label: "Choose 4 Retail Packs",
      snacks: popularSnackOptionsRetail,
    },
    {
      type: "checkbox",
      variantIds: [44956805791814],
      maxChecked: 4,
      qty: 1,
      name: "Snackie Cases",
      label: "Choose 4 Snackie Cases",
      snacks: snackieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [44956805791814],
      maxChecked: 4,
      qty: 1,
      name: "Goodie Cases",
      label: "Choose 4 Goodie Cases",
      snacks: goodieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [44956805791814],
      maxChecked: 5,
      qty: 1,
      name: "Crystie Bottles",
      label: "Choose 5 Crystie Bottles",
      snacks: crystieOptions,
    },
    // all variants
    {
      type: "select",
      variantIds: [44956805693510, 44956805726278, 44956805759046, 44956805791814],
      qty: 1,
      name: "Sticker design",
      label: "Select your sticker design",
      snacks: hamperStickerOptions,
    },
    {
      type: "hamperDatePicker",
      variantIds: [44956805693510, 44956805726278, 44956805759046, 44956805791814],
    },
    {
      type: "textField",
      variantIds: [44956805693510, 44956805726278, 44956805759046, 44956805791814],
      name: "Message",
      label: "Your message on card (optional)",
    },
  ],
  "congratulations-hampers": [
    // Dainty
    {
      type: "checkbox",
      variantIds: [43711646367814],
      maxChecked: 1,
      qty: 1,
      name: "Tea",
      label: "Choose a Tea Flavour",
      snacks: teaPouchOptions,
    },
    {
      type: "checkbox",
      variantIds: [43711646367814],
      maxChecked: 1,
      qty: 1,
      name: "Snackie Cases",
      label: "Choose a Snackie Case",
      snacks: snackieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [43711646367814],
      maxChecked: 1,
      qty: 1,
      name: "Crystie Bottles",
      label: "Choose a Crystie Bottle",
      snacks: crystieOptions,
    },
    // Lush
    {
      type: "checkbox",
      variantIds: [43711646400582],
      maxChecked: 1,
      qty: 1,
      name: "Tea",
      label: "Choose a Tea Flavour",
      snacks: teaPouchOptions,
    },
    {
      type: "checkbox",
      variantIds: [43711646400582],
      maxChecked: 2,
      qty: 1,
      name: "Snackie Cases",
      label: "Choose 2 Snackie Cases",
      snacks: snackieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [43711646400582],
      maxChecked: 1,
      qty: 1,
      name: "Crystie Bottles",
      label: "Choose a Crystie Bottle",
      snacks: crystieOptions,
    },
    // Vibrant
    {
      type: "checkbox",
      variantIds: [43711646433350],
      maxChecked: 1,
      qty: 1,
      name: "Tea",
      label: "Choose 2 Tea Flavours",
      snacks: teaPouchOptions,
    },
    {
      type: "checkbox",
      variantIds: [43711646433350],
      maxChecked: 3,
      qty: 1,
      name: "Snackie Cases",
      label: "Choose 3 Snackie Cases",
      snacks: snackieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [43711646433350],
      maxChecked: 2,
      qty: 1,
      name: "Crystie Bottles",
      label: "Choose 2 Crystie Bottles",
      snacks: crystieOptions,
    },
    // Whimsical
    {
      type: "checkbox",
      variantIds: [43711646466118],
      maxChecked: 2,
      qty: 1,
      name: "Tea",
      label: "Choose 2 Tea Flavours",
      snacks: teaPouchOptions,
    },
    {
      type: "checkbox",
      variantIds: [43711646466118],
      maxChecked: 4,
      qty: 1,
      name: "Snackie Cases",
      label: "Choose 4 Snackie Cases",
      snacks: snackieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [43711646466118],
      maxChecked: 4,
      qty: 1,
      name: "Crystie Bottles",
      label: "Choose 4 Crystie Bottles",
      snacks: crystieOptions,
    },
    // all variants
    {
      type: "select",
      variantIds: [43711646367814, 43711646400582, 43711646433350, 43711646466118],
      qty: 1,
      name: "Sticker design",
      label: "Select your sticker design",
      snacks: hamperStickerOptions,
    },
    {
      type: "hamperDatePicker",
      variantIds: [43711646367814, 43711646400582, 43711646433350, 43711646466118],
    },
    {
      type: "textField",
      variantIds: [43711646367814, 43711646400582, 43711646433350, 43711646466118],
      name: "Message",
      label: "Your message on card (optional)",
    },
  ],
  "happy-birthday-hampers": [
    // Dainty
    {
      type: "checkbox",
      variantIds: [43711643385926],
      maxChecked: 1,
      qty: 1,
      name: "Tea",
      label: "Choose a Tea Flavour",
      snacks: teaPouchOptions,
    },
    {
      type: "checkbox",
      variantIds: [43711643385926],
      maxChecked: 1,
      qty: 1,
      name: "Snackie Cases",
      label: "Choose a Snackie Case",
      snacks: snackieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [43711643385926],
      maxChecked: 1,
      qty: 1,
      name: "Crystie Bottles",
      label: "Choose a Crystie Bottle",
      snacks: crystieOptions,
    },
    // Lush
    {
      type: "checkbox",
      variantIds: [43711643418694],
      maxChecked: 1,
      qty: 1,
      name: "Tea",
      label: "Choose a Tea Flavour",
      snacks: teaPouchOptions,
    },
    {
      type: "checkbox",
      variantIds: [43711643418694],
      maxChecked: 2,
      qty: 1,
      name: "Snackie Cases",
      label: "Choose 2 Snackie Cases",
      snacks: snackieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [43711643418694],
      maxChecked: 1,
      qty: 1,
      name: "Crystie Bottles",
      label: "Choose a Crystie Bottle",
      snacks: crystieOptions,
    },
    // Vibrant
    {
      type: "checkbox",
      variantIds: [43711643451462],
      maxChecked: 1,
      qty: 1,
      name: "Tea",
      label: "Choose 2 Tea Flavours",
      snacks: teaPouchOptions,
    },
    {
      type: "checkbox",
      variantIds: [43711643451462],
      maxChecked: 3,
      qty: 1,
      name: "Snackie Cases",
      label: "Choose 3 Snackie Cases",
      snacks: snackieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [43711643451462],
      maxChecked: 2,
      qty: 1,
      name: "Crystie Bottles",
      label: "Choose 2 Crystie Bottles",
      snacks: crystieOptions,
    },
    // Whimsical
    {
      type: "checkbox",
      variantIds: [43711643484230],
      maxChecked: 2,
      qty: 1,
      name: "Tea",
      label: "Choose 2 Tea Flavours",
      snacks: teaPouchOptions,
    },
    {
      type: "checkbox",
      variantIds: [43711643484230],
      maxChecked: 4,
      qty: 1,
      name: "Snackie Cases",
      label: "Choose 4 Snackie Cases",
      snacks: snackieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [43711643484230],
      maxChecked: 4,
      qty: 1,
      name: "Crystie Bottles",
      label: "Choose 4 Crystie Bottles",
      snacks: crystieOptions,
    },
    // all variants
    {
      type: "select",
      variantIds: [43711643385926, 43711643418694, 43711643451462, 43711643484230],
      qty: 1,
      name: "Sticker design",
      label: "Select your sticker design",
      snacks: hamperStickerOptions,
    },
    {
      type: "hamperDatePicker",
      variantIds: [43711643385926, 43711643418694, 43711643451462, 43711643484230],
    },
    {
      type: "textField",
      variantIds: [43711643385926, 43711643418694, 43711643451462, 43711643484230],
      name: "Message",
      label: "Your message on card (optional)",
    },
  ],
  "thank-you-hampers": [
    // Shine
    {
      type: "checkbox",
      variantIds: [43711635390534],
      maxChecked: 1,
      qty: 2,
      name: "Tea Pouch",
      label: "Choose 2 Tea Flavours",
      snacks: teaPouchOptions,
    },
    {
      type: "checkbox",
      variantIds: [43711635390534],
      maxChecked: 1,
      qty: 1,
      name: "Snackie Case",
      label: "Choose a Snackie Case",
      snacks: snackieBoxOptions,
    },
    // Radiance
    {
      type: "checkbox",
      variantIds: [43711635423302],
      maxChecked: 1,
      qty: 1,
      name: "Tea Pouch",
      label: "Choose 2 Tea Flavours",
      snacks: teaPouchOptions,
    },
    {
      type: "checkbox",
      variantIds: [43711635423302],
      maxChecked: 1,
      qty: 1,
      name: "Snackie Case",
      label: "Choose 2 Snackie Cases",
      snacks: snackieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [43711635423302],
      maxChecked: 1,
      qty: 1,
      name: "Crystie Bottle",
      label: "Choose a Crystie Bottle",
      snacks: crystieOptions,
    },
    // Brillance
    {
      type: "checkbox",
      variantIds: [43711635456070],
      maxChecked: 2,
      qty: 1,
      name: "Tea Pouch",
      label: "Choose 3 Tea Flavours",
      snacks: teaPouchOptions,
    },
    {
      type: "checkbox",
      variantIds: [43711635456070],
      maxChecked: 3,
      qty: 1,
      name: "Snackie Case",
      label: "Choose 3 Snackie Cases",
      snacks: snackieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [43711635456070],
      maxChecked: 2,
      qty: 1,
      name: "Crystie Bottle",
      label: "Choose 2 Crystie Bottles",
      snacks: crystieOptions,
    },
    // Twinkles
    {
      type: "checkbox",
      variantIds: [43711635488838],
      maxChecked: 4,
      qty: 1,
      name: "Tea Pouch",
      label: "Choose 4 Tea Flavours",
      snacks: teaPouchOptions,
    },
    {
      type: "checkbox",
      variantIds: [43711635488838],
      maxChecked: 4,
      qty: 1,
      name: "Snackie Case",
      label: "Choose 4 Snackie Cases",
      snacks: snackieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [43711635488838],
      maxChecked: 3,
      qty: 1,
      name: "Crystie Bottle",
      label: "Choose 3 Crystie Bottles",
      snacks: crystieOptions,
    },
    // all variants
    {
      type: "select",
      variantIds: [43711635390534, 43711635423302, 43711635456070, 43711635488838],
      qty: 1,
      name: "Sticker design",
      label: "Select your sticker design",
      snacks: hamperStickerOptions,
    },
    {
      type: "hamperDatePicker",
      variantIds: [43711635390534, 43711635423302, 43711635456070, 43711635488838],
    },
    {
      type: "textField",
      variantIds: [43711635390534, 43711635423302, 43711635456070, 43711635488838],
      name: "Message",
      label: "Your message on card (optional)",
    },
  ],
  "condolences-sympathy-hampers": [
    // Care
    {
      type: "checkbox",
      variantIds: [43754415784006],
      maxChecked: 1,
      qty: 1,
      name: "Tea",
      label: "Choose a Tea Flavour",
      snacks: teaPouchOptions,
    },
    {
      type: "checkbox",
      variantIds: [43754415784006],
      maxChecked: 1,
      qty: 1,
      name: "Snackie",
      label: "Choose a Snackie Case",
      snacks: snackieBoxOptions,
    },
    // Robust
    {
      type: "checkbox",
      variantIds: [43754415816774],
      maxChecked: 1,
      qty: 1,
      name: "Tea",
      label: "Choose a Tea Flavour",
      snacks: teaPouchOptions,
    },
    {
      type: "checkbox",
      variantIds: [43754415816774],
      maxChecked: 1,
      qty: 1,
      name: "Snackie",
      label: "Choose 2 Snackie Cases",
      snacks: snackieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [43754415816774],
      maxChecked: 1,
      qty: 1,
      name: "Crystie Bottle",
      label: "Choose a Crystie Bottle",
      snacks: crystieOptions,
    },
    // Strength
    {
      type: "checkbox",
      variantIds: [43754415849542],
      maxChecked: 2,
      qty: 1,
      name: "Tea",
      label: "Choose 2 Tea Flavours",
      snacks: teaPouchOptions,
    },
    {
      type: "checkbox",
      variantIds: [43754415849542],
      maxChecked: 2,
      qty: 1,
      name: "Snackie",
      label: "Choose 2 Snackie Cases",
      snacks: snackieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [43754415849542],
      maxChecked: 2,
      qty: 2,
      name: "Crystie Bottle",
      label: "Choose 2 Crystie Bottles",
      snacks: crystieOptions,
    },
    // Vitality
    {
      type: "checkbox",
      variantIds: [43754415882310],
      maxChecked: 2,
      qty: 1,
      name: "Tea",
      label: "Choose 2 Tea Flavours",
      snacks: teaPouchOptions,
    },
    {
      type: "checkbox",
      variantIds: [43754415882310],
      maxChecked: 4,
      qty: 1,
      name: "Snackie",
      label: "Choose 4 Snackie Cases",
      snacks: snackieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [43754415882310],
      maxChecked: 4,
      qty: 1,
      name: "Crystie Bottle",
      label: "Choose 4 Crystie Bottles",
      snacks: crystieOptions,
    },
    // all variants
    {
      type: "select",
      variantIds: [43754415784006, 43754415816774, 43754415849542, 43754415882310],
      qty: 1,
      name: "Sticker design",
      label: "Select your sticker design",
      snacks: hamperStickerOptions,
    },
    {
      type: "hamperDatePicker",
      variantIds: [43754415784006, 43754415816774, 43754415849542, 43754415882310],
    },
    {
      type: "textField",
      variantIds: [43754415784006, 43754415816774, 43754415849542, 43754415882310],
      name: "Message",
      label: "Your message on card (optional)",
    },
  ],
  "wellness-healthy-hamper": [
    // Care
    {
      type: "checkbox",
      variantIds: [40834941648966],
      maxChecked: 1,
      qty: 1,
      name: "Tea",
      label: "Choose a Tea Flavour",
      snacks: teaPouchOptions,
    },
    {
      type: "checkbox",
      variantIds: [40834941648966],
      maxChecked: 1,
      qty: 1,
      name: "Snackie",
      label: "Choose a Snackie Case",
      snacks: snackieBoxOptions,
    },
    // Robust
    {
      type: "checkbox",
      variantIds: [40834941681734],
      maxChecked: 1,
      qty: 1,
      name: "Tea",
      label: "Choose a Tea Flavour",
      snacks: teaPouchOptions,
    },
    {
      type: "checkbox",
      variantIds: [40834941681734],
      maxChecked: 1,
      qty: 1,
      name: "Snackie",
      label: "Choose 2 Snackie Cases",
      snacks: snackieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [40834941681734],
      maxChecked: 1,
      qty: 1,
      name: "Crystie Bottle",
      label: "Choose a Crystie Bottle",
      snacks: crystieOptions,
    },
    // Strength
    {
      type: "checkbox",
      variantIds: [40834941714502],
      maxChecked: 2,
      qty: 1,
      name: "Tea",
      label: "Choose 2 Tea Flavours",
      snacks: teaPouchOptions,
    },
    {
      type: "checkbox",
      variantIds: [40834941714502],
      maxChecked: 2,
      qty: 1,
      name: "Snackie",
      label: "Choose 2 Snackie Cases",
      snacks: snackieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [40834941714502],
      maxChecked: 2,
      qty: 2,
      name: "Crystie Bottle",
      label: "Choose 2 Crystie Bottles",
      snacks: crystieOptions,
    },
    // Vitality
    {
      type: "checkbox",
      variantIds: [40837544673350],
      maxChecked: 2,
      qty: 1,
      name: "Tea",
      label: "Choose 2 Tea Flavours",
      snacks: teaPouchOptions,
    },
    {
      type: "checkbox",
      variantIds: [40837544673350],
      maxChecked: 4,
      qty: 1,
      name: "Snackie",
      label: "Choose 4 Snackie Cases",
      snacks: snackieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [40837544673350],
      maxChecked: 4,
      qty: 1,
      name: "Crystie Bottle",
      label: "Choose 4 Crystie Bottles",
      snacks: crystieOptions,
    },
    // all variants
    {
      type: "select",
      variantIds: [40834941648966, 40834941681734, 40834941714502, 40837544673350],
      qty: 1,
      name: "Sticker design",
      label: "Select your sticker design",
      snacks: hamperStickerOptions,
    },
    {
      type: "hamperDatePicker",
      variantIds: [40834941648966, 40834941681734, 40834941714502, 40837544673350],
    },
    {
      type: "textField",
      variantIds: [40834941648966, 40834941681734, 40834941714502, 40837544673350],
      name: "Message",
      label: "Your message on card (optional)",
    },
  ],
  "get-well-soon-hampers": [
    // Care
    {
      type: "checkbox",
      variantIds: [40831024922694],
      maxChecked: 1,
      qty: 1,
      name: "Tea",
      label: "Choose a Tea Flavour",
      snacks: teaPouchOptions,
    },
    {
      type: "checkbox",
      variantIds: [40831024922694],
      maxChecked: 1,
      qty: 1,
      name: "Snackie",
      label: "Choose a Snackie Case",
      snacks: snackieBoxOptions,
    },
    // Robust
    {
      type: "checkbox",
      variantIds: [40831024955462],
      maxChecked: 1,
      qty: 1,
      name: "Tea",
      label: "Choose a Tea Flavour",
      snacks: teaPouchOptions,
    },
    {
      type: "checkbox",
      variantIds: [40831024955462],
      maxChecked: 1,
      qty: 1,
      name: "Snackie",
      label: "Choose 2 Snackie Cases",
      snacks: snackieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [40831024955462],
      maxChecked: 1,
      qty: 1,
      name: "Crystie Bottle",
      label: "Choose a Crystie Bottle",
      snacks: crystieOptions,
    },
    // Strength
    {
      type: "checkbox",
      variantIds: [40831024988230],
      maxChecked: 2,
      qty: 1,
      name: "Tea",
      label: "Choose 2 Tea Flavours",
      snacks: teaPouchOptions,
    },
    {
      type: "checkbox",
      variantIds: [40831024988230],
      maxChecked: 2,
      qty: 1,
      name: "Snackie",
      label: "Choose 2 Snackie Cases",
      snacks: snackieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [40831024988230],
      maxChecked: 2,
      qty: 2,
      name: "Crystie Bottle",
      label: "Choose 2 Crystie Bottles",
      snacks: crystieOptions,
    },
    // Vitality
    {
      type: "checkbox",
      variantIds: [40837544771654],
      maxChecked: 2,
      qty: 1,
      name: "Tea",
      label: "Choose 2 Tea Flavours",
      snacks: teaPouchOptions,
    },
    {
      type: "checkbox",
      variantIds: [40837544771654],
      maxChecked: 4,
      qty: 1,
      name: "Snackie",
      label: "Choose 4 Snackie Cases",
      snacks: snackieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [40837544771654],
      maxChecked: 4,
      qty: 1,
      name: "Crystie Bottle",
      label: "Choose 4 Crystie Bottles",
      snacks: crystieOptions,
    },
    // all variants
    {
      type: "select",
      variantIds: [40831024922694, 40831024955462, 40831024988230, 40837544771654],
      qty: 1,
      name: "Sticker design",
      label: "Select your sticker design",
      snacks: hamperStickerOptions,
    },
    {
      type: "hamperDatePicker",
      variantIds: [40831024922694, 40831024955462, 40831024988230, 40837544771654],
    },
    {
      type: "textField",
      variantIds: [40831024922694, 40831024955462, 40831024988230, 40837544771654],
      name: "Message",
      label: "Your message on card (optional)",
    },
  ],
  "ndp-snack-box": [
    {
      type: "checkbox",
      variantIds: [44932558815302, 44932558848070, 44932558880838],
      maxChecked: 1,
      qty: 1,
      name: "Tea Flavour",
      label: "Choose Tea Flavour",
      snacks: teaPouchOptions,
    },
    {
      type: "display",
      variantIds: [44932558815302],
      html: `
      Included in hamper
      <ol style="padding: 1rem">
          <li>Flying Burger Balls Medley</li>
          <li>Butter Murukku Crackers</li>
          <li>Organic Vegan Kaya</li>
          <li>Snacks Keychain Blind Box</li>
          <li>Nostalgic Iced Gem in Goodie Box</li>
          <li>Merlion Butter Cookies in Goodie Box</li>
      </ol>
      `,
    },
    {
      type: "display",
      variantIds: [44932558848070],
      html: `
      Included in hamper
      <ol style="padding: 1rem">
          <li>Flying Burger Balls Medley</li>
          <li>Butter Murukku Crackers</li>
          <li>Organic Vegan Kaya</li>
          <li>Snacks Keychain Blind Box</li>
          <li>Worthy Ondeh Ondeh Cookies in Snackie Box</li>
          <li>Worthy Laksa Cookies in Snackie Box</li>
          <li>Nostalgic Iced Gem in Goodie Box</li>
          <li>Merlion Butter Cookies in Goodie Box</li>
          <li>Satay Crunch Peanuts in Goodie Box</li>
      </ol>
      `,
    },
    {
      type: "checkbox",
      variantIds: [44932558880838],
      maxChecked: 2,
      qty: 1,
      name: "Crystie Bottles",
      label: "Choose 2 Crystie Bottles",
      snacks: crystieOptions,
    },
    {
      type: "display",
      variantIds: [44932558880838],
      html: `
      Included in hamper
      <ol style="padding: 1rem">
          <li>Flying Burger Balls Medley</li>
          <li>Butter Murukku Crackers</li>
          <li>Organic Vegan Kaya</li>
          <li>Snacks Keychain Blind Box</li>
          <li>Worthy Ondeh Ondeh Cookies in Snackie Box</li>
          <li>Worthy Laksa Cookies in Snackie Box</li>
          <li>Nostalgic Iced Gem in Goodie Box</li>
          <li>Merlion Butter Cookies in Goodie Box</li>
          <li>Satay Crunch Peanuts in Goodie Box</li>
          <li>Merlion Keychain</li>
      </ol>
      `,
    },
    // Lion City
    {
      type: "checkbox",
      variantIds: [44932558913606],
      maxChecked: 2,
      qty: 1,
      name: "Tea Flavours",
      label: "Choose 2 Tea Flavours",
      snacks: teaPouchOptions,
    },
    {
      type: "checkbox",
      variantIds: [44932558913606],
      maxChecked: 2,
      qty: 1,
      name: "Crystie Bottles",
      label: "Choose 2 Crystie Bottles",
      snacks: crystieOptions,
    },
    {
      type: "display",
      variantIds: [44932558913606],
      html: `
      Included in hamper
      <ol style="padding: 1rem">
          <li>Flying Burger Balls Medley</li>
          <li>Butter Murukku Crackers</li>
          <li>Pandan Kaya Poofy Popcorn</li>
          <li>Macadamia Pandan Granola</li>
          <li>Organic Vegan Kaya</li>
          <li>Snacks Keychain Blind Box</li>
          <li>Worthy Ondeh Ondeh Cookies in Snackie Box</li>
          <li>Worthy Laksa Cookies in Snackie Box</li>
          <li>Nostalgic Iced Gem in Goodie Box</li>
          <li>Merlion Butter Cookies in Goodie Box</li>
          <li>Satay Crunch Peanuts in Goodie Box</li>
          <li>Merlion Keychain</li>
          <li>Iced Gem Keychain</li>
      </ol>
      `,
    },
    // all hampers
    {
      type: "hamperDatePicker",
      variantIds: [44932558815302, 44932558848070, 44932558880838, 44932558913606],
    },
    {
      type: "textField",
      variantIds: [44932558815302, 44932558848070, 44932558880838, 44932558913606],
      name: "Message",
      label: "Your message on card (optional)",
    },
  ],
  "nutty-mooncakes": [
    {
      // Harvest
      type: "checkbox",
      variantIds: [40649355919430],
      qty: 1,
      maxChecked: 1,
      name: "Mooncake",
      label: "Choose 1 Mooncake",
      snacks: mooncakeFlavours,
    },
    {
      type: "checkbox",
      variantIds: [40649355919430],
      qty: 1,
      maxChecked: 1,
      name: "Teas",
      label: "Choose 2 Tea Flavours",
      snacks: teaPartyPackOptions,
    },    
    {
      // Gratitude
      type: "checkbox",
      variantIds: [40073557803078],
      qty: 1,
      maxChecked: 2,
      name: "Mooncakes",
      label: "Choose 2 Mooncakes",
      snacks: mooncakeFlavours,
    },
    {
      type: "checkbox",
      variantIds: [40073557803078],
      qty: 1,
      maxChecked: 4,
      name: "Teas",
      label: "Choose up to 4 Tea Flavours",
      tooltip: "We will apportion your selected flavours equally",
      snacks: teaPartyPackOptions,
    },
    {
      // Reunion
      type: "checkbox",
      variantIds: [42048207978566],
      qty: 1,
      maxChecked: 2,
      name: "Mooncakes",
      label: "Choose up to 4 Mooncakes",
      tooltip: "We will apportion your selected flavours equally",
      snacks: mooncakeFlavours,
    }, 
  ],
  "deepavali-diwali-snack-box": [
    // Puja Hamper
    {
      type: "checkbox",
      variantIds: [44985511346246],
      qty: 1,
      maxChecked: 1,
      name: "Tea",
      label: "Choose 1 Tea",
      snacks: teaPouchOptions,
    }, 
    {
      type: "checkbox",
      variantIds: [44985511346246],
      qty: 1,
      maxChecked: 2,
      name: "Snackie",
      label: "Choose 2 Snackie Cases",
      snacks: snackieBoxOptions,
    }, 
    {
      type: "checkbox",
      variantIds: [44985511346246],
      qty: 1,
      maxChecked: 1,
      name: "Crystie",
      label: "Choose 1 Crystie Glass Bottle",
      snacks: crystieOptions,
    }, 
    {
      type: "display",
      variantIds: [44985511346246],
      html: `Includes
          <ol style="padding: 1rem">
            <li>4 types of murukku crackers</li>
            <li>Hamper wrapping</li>
          </ol>
          `,
    },
    // Diya Hamper
    {
      type: "checkbox",
      variantIds: [44985511379014],
      qty: 1,
      maxChecked: 2,
      name: "Tea",
      label: "Choose 2 Teas",
      snacks: teaPouchOptions,
    }, 
    {
      type: "checkbox",
      variantIds: [44985511379014],
      qty: 1,
      maxChecked: 2,
      name: "Snackie",
      label: "Choose 2 Snackie Cases",
      snacks: snackieBoxOptions,
    }, 
    {
      type: "checkbox",
      variantIds: [44985511379014],
      qty: 1,
      maxChecked: 2,
      name: "Crystie",
      label: "Choose 2 Crystie Glass Bottles",
      snacks: crystieOptions,
    }, 
    {
      type: "display",
      variantIds: [44985511379014],
      html: `Includes
          <ol style="padding: 1rem">
            <li>4 types of murukku crackers</li>
            <li>Hamper wrapping</li>
          </ol>
          `,
    },
    // Dhan Hamper
    {
      type: "checkbox",
      variantIds: [44985511411782],
      qty: 1,
      maxChecked: 2,
      name: "Tea",
      label: "Choose 2 Teas",
      snacks: teaPouchOptions,
    }, 
    {
      type: "checkbox",
      variantIds: [44985511411782],
      qty: 1,
      maxChecked: 2,
      name: "Snackie",
      label: "Choose 2 Snackie Cases",
      snacks: snackieBoxOptions,
    }, 
    {
      type: "checkbox",
      variantIds: [44985511411782],
      qty: 1,
      maxChecked: 4,
      name: "Crystie",
      label: "Choose 4 Crystie Glass Bottles",
      snacks: crystieOptions,
    }, 
    {
      type: "display",
      variantIds: [44985511411782],
      html: `Includes
          <ol style="padding: 1rem">
            <li>4 types of murukku crackers</li>
            <li>Hamper wrapping</li>
          </ol>
          `,
    },
    // all variants
    {
      type: "select",
      variantIds: [44985511346246, 44985511379014, 44985511411782],
      qty: 1,
      name: "Sticker design",
      label: "Select your sticker design",
      snacks: hamperStickerOptions,
    },
    {
      type: "hamperDatePicker",
      variantIds: [44985511346246, 44985511379014, 44985511411782],
    },
    {
      type: "textField",
      variantIds: [44985511346246, 44985511379014, 44985511411782],
      name: "Message",
      label: "Your message on card (optional)",
    },
  ],
  "mothers-day-snack-box": [
    // Adore
    {
      type: "checkbox",
      variantIds: [44175878488134],
      maxChecked: 1,
      qty: 1,
      name: "Crystie Bottle",
      label: "Choose a Crystie Bottle",
      snacks: crystieOptions,
    },
    {
      type: "checkbox",
      variantIds: [44175878488134],
      maxChecked: 2,
      qty: 1,
      name: "Tea",
      label: "Choose 2 Tea Flavours",
      snacks: teaPartyPackOptions,
    },
    // Cherish
    {
      type: "checkbox",
      variantIds: [41469383639110],
      maxChecked: 2,
      qty: 1,
      name: "Crystie Bottle",
      label: "Choose 2 Crystie Bottles",
      snacks: crystieOptions,
    },
    // Gratitude
    {
      type: "checkbox",
      variantIds: [39313754849350],
      maxChecked: 3,
      qty: 1,
      name: "Crystie Bottle",
      label: "Choose 3 Crystie Bottles",
      snacks: crystieOptions,
    },
    // Treasure
    {
      type: "checkbox",
      variantIds: [40837548081222],
      maxChecked: 3,
      qty: 1,
      name: "Crystie Bottle",
      label: "Choose 3 Crystie Bottles",
      snacks: crystieOptions,
    },
    {
      type: "checkbox",
      variantIds: [40837548081222],
      maxChecked: 2,
      qty: 1,
      name: "Tea",
      label: "Choose 2 Tea Flavours",
      snacks: teaPartyPackOptions,
    },
    // Dainty
    {
      type: "checkbox",
      variantIds: [44958939086918],
      maxChecked: 1,
      qty: 1,
      name: "Tea",
      label: "Choose a Tea Flavour",
      snacks: teaPouchOptions,
    },
    {
      type: "checkbox",
      variantIds: [44958939086918],
      maxChecked: 2,
      qty: 1,
      name: "Snackie Cases",
      label: "Choose 2 Snackie Cases",
      snacks: snackieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [44958939086918],
      maxChecked: 2,
      qty: 1,
      name: "Crystie Bottles",
      label: "Choose 2 Crystie Bottles",
      snacks: crystieOptions,
    },
    // Lush
    {
      type: "checkbox",
      variantIds: [44958939119686],
      maxChecked: 1,
      qty: 1,
      name: "Tea",
      label: "Choose a Tea Flavour",
      snacks: teaPouchOptions,
    },
    {
      type: "checkbox",
      variantIds: [44958939119686],
      maxChecked: 2,
      qty: 1,
      name: "Snackie Cases",
      label: "Choose 2 Snackie Cases",
      snacks: snackieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [44958939119686],
      maxChecked: 2,
      qty: 1,
      name: "Crystie Bottles",
      label: "Choose 2 Crystie Bottles",
      snacks: crystieOptions,
    },
    // Vibrant
    {
      type: "checkbox",
      variantIds: [44958939152454],
      maxChecked: 1,
      qty: 1,
      name: "Tea",
      label: "Choose a Tea Flavour",
      snacks: teaPouchOptions,
    },
    {
      type: "checkbox",
      variantIds: [44958939152454],
      maxChecked: 2,
      qty: 1,
      name: "Snackie Cases",
      label: "Choose 2 Snackie Cases",
      snacks: snackieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [44958939152454],
      maxChecked: 2,
      qty: 1,
      name: "Crystie Bottles",
      label: "Choose 2 Crystie Bottles",
      snacks: crystieOptions,
    },
    // Whimsical
    {
      type: "checkbox",
      variantIds: [44958939185222],
      maxChecked: 1,
      qty: 1,
      name: "Tea",
      label: "Choose a Tea Flavour",
      snacks: teaPouchOptions,
    },
    {
      type: "checkbox",
      variantIds: [44958939185222],
      maxChecked: 2,
      qty: 1,
      name: "Snackie Cases",
      label: "Choose 2 Snackie Cases",
      snacks: snackieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [44958939185222],
      maxChecked: 2,
      qty: 1,
      name: "Crystie Bottles",
      label: "Choose 2 Crystie Bottles",
      snacks: crystieOptions,
    },
    // all variants
    {
      type: "select",
      variantIds: [44958939086918, 44958939119686, 44958939152454, 44958939185222],
      qty: 1,
      name: "Sticker design",
      label: "Select your sticker design",
      snacks: hamperStickerOptions,
    },
    {
      type: "hamperDatePicker",
      variantIds: [44958939086918, 44958939119686, 44958939152454, 44958939185222],
    },
    {
      type: "textField",
      variantIds: [44958939086918, 44958939119686, 44958939152454, 44958939185222],
      name: "Message",
      label: "Your message on card (optional)",
    },
  ],
  "fathers-day-snack-box": [
    // Adore
    {
      type: "checkbox",
      variantIds: [44176867065926],
      maxChecked: 1,
      qty: 1,
      name: "Crystie Bottle",
      label: "Choose a Crystie Bottle",
      snacks: crystieOptions,
    },
    {
      type: "checkbox",
      variantIds: [44176867065926],
      maxChecked: 2,
      qty: 1,
      name: "Tea",
      label: "Choose 2 Tea Flavours",
      snacks: teaPartyPackOptions,
    },
    // Cherish
    {
      type: "checkbox",
      variantIds: [41469384327238],
      maxChecked: 2,
      qty: 1,
      name: "Crystie Bottle",
      label: "Choose 2 Crystie Bottles",
      snacks: crystieOptions,
    },
    // Gratitude
    {
      type: "checkbox",
      variantIds: [40837559156806],
      maxChecked: 3,
      qty: 1,
      name: "Crystie Bottle",
      label: "Choose 3 Crystie Bottles",
      snacks: crystieOptions,
    },
    // Treasure
    {
      type: "checkbox",
      variantIds: [43025169514566],
      maxChecked: 3,
      qty: 1,
      name: "Crystie Bottle",
      label: "Choose 3 Crystie Bottles",
      snacks: crystieOptions,
    },
    {
      type: "checkbox",
      variantIds: [43025169514566],
      maxChecked: 2,
      qty: 1,
      name: "Tea",
      label: "Choose 2 Tea Flavours",
      snacks: teaPartyPackOptions,
    },
    // Bash
    {
      type: "checkbox",
      variantIds: [44959574491206],
      maxChecked: 3,
      qty: 1,
      name: "Retail Packs",
      label: "Choose 3 Retail Packs",
      snacks: popularSnackOptionsRetail,
    },
    {
      type: "checkbox",
      variantIds: [44959574491206],
      maxChecked: 4,
      qty: 1,
      name: "Goodie Cases",
      label: "Choose 4 Goodie Cases",
      snacks: goodieBoxOptions,
    },
    // Party
    {
      type: "checkbox",
      variantIds: [44959574523974],
      maxChecked: 4,
      qty: 1,
      name: "Retail Packs",
      label: "Choose 4 Retail Packs",
      snacks: popularSnackOptionsRetail,
    },
    {
      type: "checkbox",
      variantIds: [44959574523974],
      maxChecked: 4,
      qty: 1,
      name: "Snackie Cases",
      label: "Choose 4 Snackie Cases",
      snacks: snackieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [44959574523974],
      maxChecked: 2,
      qty: 1,
      name: "Goodie Cases",
      label: "Choose 2 Goodie Cases",
      snacks: goodieBoxOptions,
    },
    // Gathering
    {
      type: "checkbox",
      variantIds: [44959574556742],
      maxChecked: 4,
      qty: 1,
      name: "Retail Packs",
      label: "Choose 4 Retail Packs",
      snacks: popularSnackOptionsRetail,
    },
    {
      type: "checkbox",
      variantIds: [44959574556742],
      maxChecked: 4,
      qty: 1,
      name: "Snackie Cases",
      label: "Choose 4 Snackie Cases",
      snacks: snackieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [44959574556742],
      maxChecked: 2,
      qty: 1,
      name: "Crystie Bottles",
      label: "Choose 2 Crystie Bottles",
      snacks: crystieOptions,
    },
    {
      type: "checkbox",
      variantIds: [44959574556742],
      maxChecked: 2,
      qty: 1,
      name: "Goodie Cases",
      label: "Choose 2 Goodie Cases",
      snacks: goodieBoxOptions,
    },
    // Celebration
    {
      type: "checkbox",
      variantIds: [44959574589510],
      maxChecked: 4,
      qty: 1,
      name: "Retail Packs",
      label: "Choose 4 Retail Packs",
      snacks: popularSnackOptionsRetail,
    },
    {
      type: "checkbox",
      variantIds: [44959574589510],
      maxChecked: 4,
      qty: 1,
      name: "Snackie Cases",
      label: "Choose 4 Snackie Cases",
      snacks: snackieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [44959574589510],
      maxChecked: 4,
      qty: 1,
      name: "Crystie Bottles",
      label: "Choose 4 Crystie Bottles",
      snacks: crystieOptions,
    },
    {
      type: "checkbox",
      variantIds: [44959574589510],
      maxChecked: 4,
      qty: 1,
      name: "Goodie Cases",
      label: "Choose 4 Goodie Cases",
      snacks: goodieBoxOptions,
    },
    // all variants
    {
      type: "select",
      variantIds: [44959574491206,44959574523974,44959574556742,44959574589510],
      qty: 1,
      name: "Sticker design",
      label: "Select your sticker design",
      snacks: hamperStickerOptions,
    },
    {
      type: "hamperDatePicker",
      variantIds: [44959574491206,44959574523974,44959574556742,44959574589510],
    },
    {
      type: "textField",
      variantIds: [44959574491206,44959574523974,44959574556742,44959574589510],
      name: "Message",
      label: "Your message on card (optional)",
    },
  ],
  "hari-raya-snack-box": [
    {
      type: "select",
      variantIds: [40502542303302],
      qty: 1,
      name: "drink",
      label: "Choose a drink",
      snacks: remedyOptions,
    },
    // Mubarak Hamper
    {
      type: "hamperDatePicker",
      variantIds: [42330920550470],
    },
    {
      type: "checkbox",
      variantIds: [42330920550470],
      maxChecked: 2,
      qty: 1,
      name: "Hari Raya Specials",
      label: "Choose 2 Hari Raya Specials",
      snacks: hariRayaSpecials,
    },
    {
      type: "checkbox",
      variantIds: [42330920550470],
      maxChecked: 2,
      qty: 1,
      name: "Retail Packs",
      label: "Choose 2 Retail Packs",
      snacks: hariRayaSnacks200,
    },
    {
      type: "display",
      variantIds: [42330920550470],
      html: `Included in the package
          <ol style="padding: 1rem">
            <li>Sugar Sweet Peanuts in Goodie Case</li>
            <li>Crunchy Medley in Goodie Case</li>
            <li>Juicy Apricots in Goodie Case</li>
          </ol>
          Packed and wrapped as hamper
          `,
    },
    {
      type: "textField",
      variantIds: [42330920550470],
      name: "Message",
      label: "Your message on card",
    },
    // Kenduri Hamper
    {
      type: "hamperDatePicker",
      variantIds: [42330920583238],
    },
    {
      type: "checkbox",
      variantIds: [42330920583238],
      maxChecked: 4,
      qty: 1,
      name: "Retail Packs",
      label: "Choose 4 Retail Packs",
      snacks: hariRayaSnacks200,
    },
    {
      type: "display",
      variantIds: [42330920583238],
      html: `Included in the package
          <ol style="padding: 1rem">
            <li>Pandan Makmur Cookies</li>
            <li>Pandan Pineapple Tarts</li>
            <li>Colourful Donut Cookies</li>
            <li>Lazat Cornflake Cookies</li>
            <li>Sugar Sweet Peanuts in Goodie Case</li>
            <li>Crunchy Medley in Goodie Case</li>
            <li>Juicy Apricots in Goodie Case</li>
            <li>Sambal Shrimp Rolls in Snackie Case</li>
          </ol>
          Packed and wrapped as hamper
          `,
    },
    {
      type: "textField",
      variantIds: [42330920583238],
      name: "Message",
      label: "Your message on card",
    },
  ],
  "nuts-about-you-snack-gift-box": [
    // Adore
    {
      type: "checkbox",
      variantIds: [44165389156422],
      maxChecked: 1,
      qty: 1,
      name: "Crystie Bottle",
      label: "Choose a Crystie Bottle",
      snacks: crystieOptions,
    },
    {
      type: "checkbox",
      variantIds: [44165389156422],
      maxChecked: 2,
      qty: 1,
      name: "Tea",
      label: "Choose 2 Tea Flavours",
      snacks: teaPartyPackOptions,
    },
    // Cherish
    {
      type: "checkbox",
      variantIds: [40488552202310],
      maxChecked: 2,
      qty: 1,
      name: "Crystie Bottle",
      label: "Choose 2 Crystie Bottles",
      snacks: crystieOptions,
    },
    // Gratitude
    {
      type: "checkbox",
      variantIds: [42518637838406],
      maxChecked: 3,
      qty: 1,
      name: "Crystie Bottle",
      label: "Choose 3 Crystie Bottles",
      snacks: crystieOptions,
    },
    // Treasure
    {
      type: "checkbox",
      variantIds: [40837552373830],
      maxChecked: 3,
      qty: 1,
      name: "Crystie Bottle",
      label: "Choose 3 Crystie Bottles",
      snacks: crystieOptions,
    },
    {
      type: "checkbox",
      variantIds: [40837552373830],
      maxChecked: 2,
      qty: 1,
      name: "Tea",
      label: "Choose 2 Tea Flavours",
      snacks: teaPartyPackOptions,
    },
    // -- Blue version
    // Adore
    {
      type: "checkbox",
      variantIds: [44983152803910],
      maxChecked: 1,
      qty: 1,
      name: "Crystie Bottle",
      label: "Choose a Crystie Bottle",
      snacks: crystieOptions,
    },
    {
      type: "checkbox",
      variantIds: [44983152803910],
      maxChecked: 2,
      qty: 1,
      name: "Tea",
      label: "Choose 2 Tea Flavours",
      snacks: teaPartyPackOptions,
    },
    // Cherish
    {
      type: "checkbox",
      variantIds: [44983152836678],
      maxChecked: 2,
      qty: 1,
      name: "Crystie Bottle",
      label: "Choose 2 Crystie Bottles",
      snacks: crystieOptions,
    },
    // Gratitude
    {
      type: "checkbox",
      variantIds: [44983152869446],
      maxChecked: 3,
      qty: 1,
      name: "Crystie Bottle",
      label: "Choose 3 Crystie Bottles",
      snacks: crystieOptions,
    },
    // Treasure
    {
      type: "checkbox",
      variantIds: [44983152902214],
      maxChecked: 3,
      qty: 1,
      name: "Crystie Bottle",
      label: "Choose 3 Crystie Bottles",
      snacks: crystieOptions,
    },
    {
      type: "checkbox",
      variantIds: [44983152902214],
      maxChecked: 2,
      qty: 1,
      name: "Tea",
      label: "Choose 2 Tea Flavours",
      snacks: teaPartyPackOptions,
    },
    // all variants
    {
      type: "select",
      variantIds: [44165389156422, 40488552202310, 42518637838406, 40837552373830, 44983152803910, 44983152836678, 44983152869446, 44983152902214],
      qty: 1,
      name: "Sticker design",
      label: "Select your sticker design",
      snacks: hamperStickerOptions,
    },
    {
      type: "hamperDatePicker",
      variantIds: [44165389156422, 40488552202310, 42518637838406, 40837552373830, 44983152803910, 44983152836678, 44983152869446, 44983152902214],
    },
    {
      type: "textField",
      variantIds: [44165389156422, 40488552202310, 42518637838406, 40837552373830, 44983152803910, 44983152836678, 44983152869446, 44983152902214],
      name: "Message",
      label: "Your message on card (optional)",
    },
  ],
  "snack-party-cones": [
    {
      type: "checkbox",
      variantIds: [42016747192390, 42016747225158, 42016747257926],
      maxChecked: 4,
      qty: 1,
      name: "Flavours",
      label: "Choose up to 4 flavours",
      tooltip: "We will apportion your selected snacks equally",
      snacks: snackConeOptions,
    },
  ],
  "wedding-favours": [
    {
      type: "checkbox",
      variantIds: [40505270665286, 40505270698054, 40706652405830],
      maxChecked: 4,
      qty: 1,
      name: "Flavours",
      label: "Flavours (Up to 4)",
      tooltip: "We will apportion your selected flavours equally",
      snacks: wedingPartyPacksOptions,
    },
    // Bitsie
    {
      type: "checkbox",
      variantIds: [45046186311750, 45046186344518],
      maxChecked: 4,
      qty: 1,
      name: "Flavours",
      label: "Flavours (Up to 4)",
      tooltip: "We will apportion your selected flavours equally",
      snacks: bitsieOptions,
    },
    // all
    {
      type: "imageSelect",
      variantIds: [40505270665286, 40505270698054, 40706652405830, 45046186311750, 45046186344518],
      qty: 1,
      name: "Label",
      label: "Choose your label",
      tooltip: "Size (LxH): 5cm x 5cm",
      images: weddingImageOptions.concat([
        {
          name: "Custom",
          url: "https://cdn.shopify.com/s/files/1/1717/9065/files/Custom_label.jpg?v=1692952705",
        },
      ]),
    },
    {
      type: "textField",
      variantIds: [40505270665286, 40505270698054, 40706652405830, 45046186311750, 45046186344518],
      name: "Names",
      label: "Names (for named labels)",
    },
    {
      type: "textField",
      variantIds: [40505270665286, 40505270698054, 40706652405830, 45046186311750, 45046186344518],
      name: "Date or subtext",
      label: "Date or subtext",
    },
  ],
  "premium-nuts-glass-bottles": [
    {
      type: "checkbox",
      variantIds: [46088812593222],
      maxChecked: 4,
      qty: 1,
      name: "Flavours",
      label: "Choose up to 4 flavours",
      snacks: crystieOptions,
    },
    {
      type: "checkbox",
      variantIds: [46088812625990],
      maxChecked: 4,
      qty: 1,
      name: "Flavours",
      label: "Choose up to 4 flavours",
      snacks: crystieOptions,
    },
  ],
  "bitsie-jars": [
    {
      type: "checkbox",
      variantIds: [45046201090118],
      maxChecked: 4,
      qty: 1,
      name: "Flavours",
      label: "Choose up to 4 flavours",
      snacks: bitsieOptions,
    },
    {
      type: "checkbox",
      variantIds: [45046201122886],
      maxChecked: 4,
      qty: 1,
      name: "Flavours",
      label: "Choose up to 4 flavours",
      snacks: bitsieOptions,
    },
    {
      type: "checkbox",
      variantIds: [45046201188422],
      maxChecked: 4,
      qty: 1,
      name: "Flavours",
      label: "Choose up to 4 flavours",
      snacks: bitsitePremiumOptions.concat(bitsieOptions),
    },
    {
      type: "checkbox",
      variantIds: [45046201221190],
      maxChecked: 4,
      qty: 1,
      name: "Flavours",
      label: "Choose up to 4 flavours",
      snacks: bitsitePremiumOptions.concat(bitsieOptions),
    },
  ],
  "build-your-own-mix": [
    {
      type: "custom-medley",
      variantIds: [43783275380806],
      maxChecked: 5,
      qty: 1,
      name: "Flavours",
      label: "Choose up to 5 ingredients",
      snacks: customMedleyOptions,
      // custom field
      totalWeight: 200,
    },
    {
      type: "custom-medley",
      variantIds: [43783275413574, 43783275479110],
      maxChecked: 5,
      qty: 1,
      name: "Flavours",
      label: "Choose up to 5 ingredients",
      snacks: customMedleyOptions,
      // custom field
      totalWeight: 500,
    },
    {
      type: "custom-medley",
      variantIds: [43783275446342],
      maxChecked: 5,
      qty: 1,
      name: "Flavours",
      label: "Choose up to 5 ingredients",
      snacks: customMedleyOptions,
      // custom field
      totalWeight: 1000,
    },
  ],
};

if (!customElements.get("custom-options")) {
  customElements.define(
    "custom-options",
    class CustomOptions extends HTMLElement {
      constructor() {
        super();
        this.options = routeOptions;
      }

      connectedCallback() {
        try {
          // Parse options from the data attribute
          // this.options = JSON.parse(this.dataset.options || "{}");

          // Get product handle and variant ID
          const productHandle = this.dataset.productHandle;
          const variantId = parseInt(this.dataset.variantId, 10);

          // Match options for the product handle and variant ID
          const matchedOptions =
            this.options[productHandle]?.filter((option) => option.variantIds.includes(variantId) || option.variantIds[0] === "all" ) || [];

          // Render the matched options
          if (matchedOptions.length > 0) {
            this.renderOptions(matchedOptions);
          } else {
            console.log(`No matching options found for product ${productHandle} with variant ID ${variantId}`);
          }

          // if we need to handle variant changes, we can subscribe to the event publish inside product-info.js
          // this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          //   const { sectionId, html, variant } = event.data;

          //   // Handle the event (e.g., update custom options based on the new variant)
          //   console.log("Variant changed:", { sectionId, html, variant });
          // });
        } catch (error) {
          console.error("Error in custom-options component:", error);
        }
      }

      // Uncomment if you need to handle variant changes
      // disconnectedCallback() {
      //   // Unsubscribe from the event to avoid memory leaks
      //   this.variantChangeUnsubscriber?.();
      // }

      renderOptions(matchedOptions) {
        if (!matchedOptions || matchedOptions.length === 0) return;

        const formId = this.dataset.formId || "product-form";

        matchedOptions.forEach((option) => {
          if (!option || !option.type) {
            console.warn("Invalid option object:", option);
            return;
          }

          let html = "";

          try {
            switch (option.type) {
              case "checkbox":
                if (typeof renderCheckBoxes === "function" && option.snacks) {
                  html = renderCheckBoxes(option, formId);
                } else {
                  console.warn(`renderCheckBoxes function not found or option.snacks is missing for option:`, option);
                }
                break;
              case "imageSelect":
                if (typeof renderImageHtml === "function" && option.images) {
                  html = renderImageHtml(option, formId);
                } else {
                  console.warn(`renderImageHtml function not found or option.images is missing for option:`, option);
                }
                break;
              case "file":
                if (typeof renderFileUpload === "function") {
                  html = renderFileUpload(option, formId);
                } else {
                  console.warn(`renderFileUpload function not found for option:`, option);
                }
                break;
              case "display":
                if (typeof renderDisplayHtml === "function" && option.html) {
                  html = renderDisplayHtml(option);
                } else {
                  console.warn(`renderDisplayHtml function not found or option.html is missing for option:`, option);
                }
                break;
              case "select":
                if (typeof renderSelect === "function" && option.snacks) {
                  html = renderSelect(option, formId);
                } else {
                  console.warn(`renderSelect function not found or option.snacks is missing for option:`, option);
                }
                break;
              case "date":
                if (typeof renderDate === "function") {
                  html = renderDate(option, formId);
                } else {
                  console.warn(`renderDate function not found for option:`, option);
                }
                break;
              case "timeslot":
                if (typeof renderTimeSlot === "function") {
                  html = renderTimeSlot(option, formId);
                } else {
                  console.warn(`renderTimeSlot function not found for option:`, option);
                }
                break;
              case "hamperDatePicker":
                if (typeof renderHamperDatePicker === "function") {
                  html = renderHamperDatePicker(option, formId);
                } else {
                  console.warn(`renderHamperDatePicker function not found for option:`, option);
                }
                break;
              case "textField":
                if (typeof renderTextArea === "function") {
                  html = renderTextArea(option, formId);
                } else {
                  console.warn(`renderTextArea function not found for option:`, option);
                }
                break;
              case "custom-medley":
                if (typeof renderCustomMedley === "function") {
                  html = renderCustomMedley(option, formId);
                } else {
                  console.warn(`renderCustomMedley function not found for option:`, option);
                }
                break;
              default:
                console.warn(`Unknown option type: ${option.type}`);
            }

            // Wrap the generated HTML in a div with class "option-group"
            if (html) {
              const wrappedHtml = `<div class="options accordion option-group">${html}</div>`;
              this.insertAdjacentHTML("beforeend", wrappedHtml);
            }
          } catch (error) {
            console.error(`Error rendering option type ${option.type}:`, error);
          }
        });

        renderFlatPickr();

        // Add popular choices indicator
        if (typeof addPopularChoices === "function") {
          try {
            addPopularChoices();
          } catch (error) {
            console.error("Error adding popular choices:", error);
          }
        }
      }
      getSelectedVariant(productInfoNode) {
        const selectedVariant = productInfoNode.querySelector("variant-selects [data-selected-variant]")?.innerHTML;
        return !!selectedVariant ? JSON.parse(selectedVariant) : null;
      }
    }
  );
}
